// noinspection JSUnusedGlobalSymbols

import { BrowserStorageType, Helper } from "../core/util/helper.js";
import { Legend, ResourcePlanningSchedulerLegendEntryViewModel } from "./legend.js";
import { JourneyLegKind, Scheduler, SchedulerClasses, SchedulerResourceHeaderClasses } from "./scheduler.js";
import { OnChangeField, OpenExternalInfo, Settings } from "./settings.js";
import { SlotSearchSettings, WorkList } from "./workList.js";
import { Sheet, SheetEventType } from "../../siteManagement/sheet.js";
import { AppHelper } from "../appHelper.js";
import { Config } from "../core/config/config.js";
import {
    CapacityColorClasses,
    CapacityRefreshMode,
    ConsiderGeoMode,
    ConsiderSkillMode,
    FindAvailableResourcesConfig,
    ResourceSlot,
    ResourceWithSlots
} from "./capacityDiagram.js";

import { NotificationHelper } from "../core/util/notificationHelper.js";
import { ResourcePlanningHelper } from "../core/util/resourcePlanningHelper.js";
import { General } from "../../siteManagement/general.js";
import { RightDrawerContainer } from "../core/components/rightDrawerContainer.js";
import { DirectionsApp, DirectionsConfig, GeomapParameterContainer } from "../geomap/directions/directions.js";
import { FullHeightContainer } from "../core/components/FullHeighContainer.js";
import { PageTitle } from "../core/components/pageTitle.js";
import { BMenuProps, Menu } from "../core/components/menu.js";
import { Dialog, DialogAction } from "../core/components/dialog.js";
import { ListBox } from "../core/components/listBox.js";
import { FieldInstance } from "../core/components/field.js";
import { ComponentHelper } from "../core/util/componentHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { ContinuousPeriodUnit, SuitableResourceSearchSettings } from "./availableResourceSearch.js";
import { GeomapRPCService, RouteColors } from "../geomap/geomapRPCService.js";
import { RSplitter, RSplitterDirection } from "../core/components/rSplitter.js";
import { createHtppServiceInstance, HTTPRequestConfig, HTTPRequestType, HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { EntityReminders } from "../reminders/reminders.js";
import { BookmarkBtn } from "../bookmark/bookmarkBtn.js";
import {
    ResourcePlaningGroupingHelper,
    ResourcePlanningGroupingDialog,
    ResourcePlanningGroupingDialogProps
} from "../resourcePlanningGrouping/resourcePlanningGrouping.js";
import { SearchHelper } from "../core/util/searchfieldHelper.js";
import { ModalHelper } from "../../siteManagement/showmodal.js";
import { FixMode, MultiSelectAction, MultiselectActionInfo, MultiselectHelper } from "./multiselectHelper.js";
import { SearchType } from "./graphicFocussingManager.js";
import { Util } from "./utils.js";
import { SortingInfo } from "../userSettings/assignmentSorting.js";
import { OpenResourcePlanningDeletionDialog } from "../resourcePlanningDialogs/resourcePlanningDeletionDialog.js";
import { AdditionalEventMovingInfo, OpenEventMovingDialog } from "./dialogs/eventMovingDialog.js";
import { SkillCategory } from "../generalSettings/skills/skillsInterfaces.js";
import { SlotDebugDates, SlotDebugResource } from "../core/components/slotDebugInfo.js";
import { AssignmentTraveldataModel, TraveldataModel } from "../resourcePlanning/resourcePlanning.js";
import { Entity, Metadata } from "../core/components/commonApp.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import { ProjectFilterHistoryItem } from "./extendedProjectFilter.js";
import { FavoriteFilter } from "./favoriteFilterManager.js";
import {Commands} from "../core/util/commandManager.js";
import axios, { CancelTokenSource } from "axios";
import React from "react";
export default class ResourcePlanningSchedulerApp extends React.Component<ResourcePlanningSchedulerAppProps, ResourcePlanningSchedulerState> {
    private schedulerRef: Scheduler = null;
    private settingsRef: Settings = null;
    private workListRef: WorkList = null;
    private readonly _dialogActions: Array<DialogAction> = [];
    private _refreshing: boolean = false;
    private lastCancelToken: CancelTokenSource = null;

    private readonly settings: ResourcePlanningSchedulerSettingsViewModel;
    private slotSearchSettings: SlotSearchSettings = {
        slotEnableDebugMode: true,
        slotRespectSlotResourceFilter: false,
        considerGeo: ConsiderGeoMode.Exact,
        considerSkills: ConsiderSkillMode.Off,
        considerMainGroup: true,
        considerGroup: false,
        considerFlags: false,
        considerSla: false
    };
    private focusing: {
        data: any[];
        index: number;
        searchType: SearchType;
        value: string;
    } = { data: [], index: -1, searchType: null, value: null }

    private readonly _initData: ResourcePlanningSchedulerDataViewModel = null;
    private columnTemplate: string;

    private _getData(): ResourcePlanningSchedulerDataViewModel {
        if (this.schedulerRef == null)
            return this._initData;
        return this.schedulerRef.getData();
    }

    private _getEventById(id: string): ResourcePlanningSchedulerEventViewModel {
        return this.schedulerRef?.getEventById(id);
    }

    private actions: ResourcePlanningSchedulerActions =
        {
            doRefresh: () => {
                this.settings.DoNotChangeCellWidth = true;
                this.doRefresh().then();
            },
            openEvent: (id: string, resourceId: string) => {
                this.openEvent(id, resourceId)
            },
            deleteEvent: (id: string) => {
                if (!Helper.hasValue(id)) 
                    id = this.schedulerRef?.getMarkedEvent()?.Id;
                this.deleteEvent(id).then() 
            },
            newFromResource: (resourceId: string) => { this.newFromResource(resourceId) },
            newPMFromResource: (resourceId: string) => { this.newPmFromResource(resourceId) },
            copyEvent: (id: string, newStart: Date, newEnd: Date, newResourceId: string) => { this.copyEvent(id, newStart, newEnd, newResourceId).then() },
            splitEvent: (id: string, newResourceId: string) => { this.splitEvent(id, newResourceId).then() },
            copyToResources: (id: string) => { this.copyToResources(id) },
            splitToResources: (id: string) => { this.splitToResources(id) },
            moveEvent: (id: string, newStart: Date, newEnd: Date, newResourceId: string, oldResourceId: string, resizeAction: boolean, byDelta: boolean) => {
                this.moveEvent(id, newStart, newEnd, newResourceId, oldResourceId, resizeAction, byDelta).then()
            },
            openResource: (resourceId: string) => { this.openResource(resourceId) },
            newFromSelection: (resourceId: string, start: Date, end: Date) => { this.newFromSelection(resourceId, start, end) },
            newPMFromSelection: (resourceId: string, start: Date, end: Date) => { this.newPmFromSelection(resourceId, start, end) },
            calculateRoute: (id: string) => { this.calculateRoute(id) },
            calculateTravelTimes: (id: string) => { this.calculateTravelTimes(id) },
            toggleGeomap: () => { this.toggleGeomap(); },
            updateSlotSettings: (settings: SlotSearchSettings) => {
                this.slotSearchSettings = settings;
                this.saveSlotSettings();
                if (this.state.interactiveSlotModeActive) {
                    const id = this.getSlotModeSourceId();
                    if (id == null)
                        this.setState({}); //update WorkLst buttons state
                    else
                        this.actions.slotWorkListChanged();
                }
            },
            toggleCapacity: (isOn: boolean) => {
                this.settings.DisplayCapacityChart = isOn;
                this.saveDisplaySettings();
                //if (!this.settings.DisplayCapacityChart) {
                //    this.ignoreProjectFilterActive = false;
                //}
                this.setConsiderHiddenAssignmentsForCapacity();
                this.schedulerRef.toggleCapacity(isOn, () => {
                    //update für Actions (unten-links), sonst nicht sichtbar 
                    this.setState({});
                });
            },
            signalIgnoreProjectFilterInCapacity: (ignore: boolean, doRefresh: boolean) => {
                //debugger;
                if (!this.settings.DisplayCapacityChart)
                    ignore = false;
                this.settings.CapacityIgnoreProjectFilter = ignore;
                this.saveDisplaySettings();
                this.setConsiderHiddenAssignmentsForCapacity();

                if (doRefresh)
                    this.doRefresh().then();
            },
            toggleWorklistInTable: (isOn: boolean) => {
                this.settings.DisplayWorkListInTable = isOn;
                this.saveDisplaySettings();
                this.saveSlotSettings();
                const interactiveMode = this.state.interactiveSlotModeActive;
                this.suitableResourcesSearchSettings = null;
                this.setState({
                    slotModeActive: false,
                    interactiveSlotModeActive: !isOn ? false : this.state.interactiveSlotModeActive,
                    generatedSlots: []
                },
                    () => {
                        if (!isOn) {
                            if (interactiveMode) {
                                this.schedulerRef.refresh(this._getData(), false, () => {
                                    this.updateWorklist()
                                }).then();

                            } else {
                                this.schedulerRef.getDps().show();
                            }
                        }
                    });
            },
            //this will enable/disable interactiveSlotModeActive, but there is no selected Assignment jet for slot-search
            toggleInteractiveSlotMode: (isOn: boolean) => {
                if (!isOn) {
                    this.setState({ interactiveSlotModeActive: false, slotModeActive: false, generatedSlots: [], selectedAssignmentForSlotId: null },
                        () => {
                            this.schedulerRef.refresh(this._getData(), false, () => { this.updateWorklist(); }).then();
                        });
                } else {
                    if (this.settings.DisplayWorkListInTable && !this.state.slotModeActive) {
                        this.settings.DoNotChangeCellWidth = false;
                        //todo: need to check this
                        this.setState({ interactiveSlotModeActive: true }, () => {
                            this.settings.DoNotChangeCellWidth = true;
                            if (this.workListRef != null && this.workListRef._grid != null)
                                this.workListRef._grid.getGridRef().trigger("change");
                            this.updateWorklist();
                        });
                    }
                }
            },
            slotWorkListChanged: () => {
                this.actions.computeSlots(this.getSlotModeSourceId());
            },
            toggleSlaView: (isOn: boolean, doRefresh: boolean = true) => {
                if (isOn)
                    this.actions.toggleFlagView(0, false);
                this.settings.SlaViewActive = isOn;
                if (isOn && this.settings.AssignmentGroupingViewActive)
                    this.settings.AssignmentGroupingViewActive = false;
                this.saveDisplaySettings();
                if (doRefresh)
                    this.schedulerRef.refresh(this._getData(), false, () => this.actions.slotWorkListChanged()).then();
            },
            toggleAssigmentGroupingView: (isOn: boolean) => {
                if (isOn)
                    this.actions.toggleFlagView(0, false);
                this.settings.AssignmentGroupingViewActive = isOn;
                if (isOn && this.settings.SlaViewActive)
                    this.settings.SlaViewActive = false;
                if (isOn && this.settings.ShowProjectColor_Enabled && this.settings.ShowProjectColor)
                    this.settings.ShowProjectColor = false;
                this.saveDisplaySettings();
                this.schedulerRef.refresh(this._getData(), false).then();
            },
            focusEvent: (id: string) => {
                this.schedulerRef.focusEvent(id);
            },
            focusSlotEvent: (id: string) => {
                this.schedulerRef.focusSlotEvent(id);
            },
            markEvent: (id: string) => {
                this.schedulerRef.markEvent(id);
            },
            fitToWorkingTime: (id: string, resourceId: string) => {
                this.fitToWorkingTime(id, resourceId);
            },
            openSlot: (e) => this.viewSlotEvent(e),
            useSlot: (r, s) => this.acceptSlot(s, r),
            computeSlots: (id: string) => {
                if (this.checkSlotModeSourceId(id)) {
                    this.openAvailableResourceSearch(id);
                    if (this.workListRef != null)
                        this.workListRef.selectRow(id);
                }
            },
            newAssigmentGrouping: (id: string) => {
                const event = this.getEvent(id);
                if (event) {
                    this.newAssigmentGrouping([event], true);
                }
            },
            deleteAssigmentGrouping: (id: string) => {
                const event = this.getEvent(id);
                if (event) {
                    this.deleteAssigmentGrouping([event]);
                }
            },
            listAssigmentGrouping: (id: string) => {
                const event = this.getEvent(id);
                if (event) {
                    this.listAssigmentGrouping(event.Gruppierung);
                }
            },
            changeAssigmentGrouping: (id: string) => {
                const event = this.getEvent(id);
                if (event) {
                    this.changeAssigmentGrouping([event]);
                }
            },
            changeToLastAssigmentGrouping: (id: string, last: number) => {
                const event = this.getEvent(id);
                if (event) {
                    this.changeToLastAssigmentGrouping([event], last);

                }
            },
            toggleMultiSelect: (isOn: boolean) => {
                this.setState({ multiSelectActive: isOn }, () => {
                    if (!isOn)
                        this.actions.multiSelectEventsSelected([]);
                    this.schedulerRef.refresh(this._getData(), false).then();
                });
            },
            multiSelectEventsSelected: (events: Array<ResourcePlanningSchedulerEventViewModel>) => {
                this.setState({ multiSelectEvents: events });
            },
            executeMultiSelectAction: async (action: MultiSelectAction) => {

                const events = this.state.multiSelectEvents;
                switch (action) {
                    case MultiSelectAction.Delete:
                        await MultiselectHelper.Delete(events);
                        break;
                    case MultiSelectAction.MoveToResource:
                        const ressNr = await MultiselectHelper.OpenRessourceSearch(events);
                        await MultiselectHelper.MoveToRessource(events, ressNr)
                        break;
                    case MultiSelectAction.MoveToContainer:
                        await MultiselectHelper.MoveToContainer(events);
                        break;
                    case MultiSelectAction.FilterProjects:
                        const projNrs = events.map(f => { return f.Id.split("|")[0] }).filter((value, index, self) => { return self.indexOf(value) === index; });
                        const changes: Array<OnChangeField> = [{ model: "SelectedFilterGuid" }, { model: "ProjNrs" }];
                        const values: Array<any> = [null, projNrs];
                        await this.handleChangeFilterField(changes, values);
                        break;
                }
                this.setState({ multiSelectEvents: [] }, () => {
                    this.schedulerRef.getDps().multiselect.clear();
                    this.doRefresh();
                })
            },
            executeMultiSelectFixing: async (action: "fix" | "defix", fixMode: FixMode) => {
                const events = this.state.multiSelectEvents;
                switch (action) {
                    case "fix":
                        await MultiselectHelper.FixEvents(events, fixMode);
                        break;
                    case "defix":
                        await MultiselectHelper.DeFixEvents(events, fixMode);
                        break;
                }
                this.setState({ multiSelectEvents: [] }, () => {
                    this.schedulerRef.getDps().multiselect.clear();
                    this.doRefresh();
                })
            },
            addProjNr: (projNr: string) => {
                if(Config.user.activeExtendedProjectFilter){
                    const changes: Array<OnChangeField> = [{ model: "SelectedFilterGuid" },{ model: "ProjNrs" }];
                    const values: Array<any> = [null];
                    let result = DialogHelper.choose(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.DeactivateAllProjectNumbers").replace("{projNr}", projNr), [{label: Helper.getTranslation("Standard.Abbrechen"), value: -1 }, {label: Helper.getTranslation("Server.No"), value: 0}, {label: Helper.getTranslation("Server.Yes"), value: 1, primary: true}]);
                    result.then((value) => {
                        if(value > -1){
                            changes.push({model: "ProjNrsHistory"});
                            changes.push({model: "ActiveExtendedProjectFilter"});
                            let copyProjFilter: ProjectFilterHistoryItem[] = Helper.loadDataFromStorage(Config.user.userName + "_ExtProjFilter");
                            if(!Helper.hasValue(copyProjFilter)){
                                copyProjFilter = [];
                            }
                            let index = copyProjFilter.findIndex(item => item.ProjNr == projNr);
                            if(index == -1){
                                let newItem: ProjectFilterHistoryItem = {ProjNr: projNr, Active: true, CreateDate: new Date()};
                                copyProjFilter.push(newItem);
                            }else{
                                copyProjFilter[index].Active = true;
                            }
                            if(value == 1){
                                copyProjFilter.forEach(item => {
                                    if(item.ProjNr != projNr) {
                                        item.Active = false;
                                    }
                                });
                            }
                            values.push(copyProjFilter.filter(f => f.Active).map(f => f.ProjNr));
                            values.push(copyProjFilter);
                            values.push(true);
                            Helper.saveDataToStorage(Config.user.userName + "_ExtProjFilter", copyProjFilter, false);
                            this.handleChangeFilterField(changes, values).then();
                        }
                        
                    });
                }
            },
            filterByProjNr: (projNr: string) => {
                const changes: Array<OnChangeField> = [{ model: "SelectedFilterGuid" },{ model: "ProjNrs" }];
                const values: Array<any> = [null,[projNr]];
                this.handleChangeFilterField(changes, values).then();
                //todo: check needed?
                //this.settingsRef.setState({})
            },
            processAssigmentGroupingList: (action: MultiSelectAction) => {
                const events = this.state.multiSelectEvents;

                switch (action) {
                    case MultiSelectAction.Delete:
                        this.deleteAssigmentGrouping(events);
                        break;
                    case MultiSelectAction.New:
                        this.newAssigmentGrouping(events)
                        break;
                    case MultiSelectAction.Change:
                        this.changeAssigmentGrouping(events)
                        break;
                    case MultiSelectAction.ChangeLast:
                        let last = Helper.loadDataFromStorage("AssignentGroupingLastNew", BrowserStorageType.Session);
                        if (last === undefined)
                            last = 0;
                        if (last > 0)
                            this.changeToLastAssigmentGrouping(events, last);
                        break;
                }

                this.setState({ multiSelectEvents: [] }, () => {
                    this.schedulerRef.getDps().multiselect.clear();
                    this.updateWorklist();
                })
            },
            toggleFlagView: (mode: 0 | 1 | 2, doRefresh: boolean) => {
                this.props.settings.FlagMode = mode;
                if (mode > 0)
                    this.settings.AssignmentGroupingViewActive = false
                this.saveDisplaySettings();
                if (doRefresh)
                    this.doRefresh().then();
            },
            assignAreaToResource: async (flagId, ressNr, start, end) => {
                const reloadFlags = this.settings.Flags.findIndex(f => f.Id == flagId) == -1;
                if (reloadFlags) {
                    await this.reloadFlags();
                }
                //console.log(start, end)

                const result = await HTTPService
                    .noBusyIndicator()
                    .get<JsonResultClass<{ Id: string }[]>>(`ResourcePlanningScheduler/AssignAreaToResource?flagId=${flagId}&ressNr=${ressNr}&start=${start}&end=${end}`);
                if (result.Code == 0) {
                    const data = result.Data;
                    let lst: { Id: string }[] = JSON.parse(JSON.stringify(this._getData().SettingsPlanningBoard.GantColoring));
                    for (let i = 0; i < data.length; i++) {
                        const index = lst.findIndex(f => f.Id == data[i].Id)
                        if (index > -1) {
                            lst[index] = data[i];
                        } else {
                            lst.push(data[i]);
                        }
                    }
                    const oldData = this._getData();
                    oldData.SettingsPlanningBoard.GantColoring = lst as any;
                    await this.schedulerRef.refresh(oldData, false);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            },
            removeFlagsFromResource: async (ressNr, start, end) => {
                const result = await HTTPService
                    .noBusyIndicator()
                    .get<JsonResultClass>(`ResourcePlanningScheduler/RemoveFlagsFromResource?ressNr=${ressNr}&start=${start}&end=${end}`);
                if (result.Code == 0) {
                    const oldData = this._getData();
                    oldData.SettingsPlanningBoard.GantColoring = oldData.SettingsPlanningBoard.GantColoring.filter((item) => {
                        return (item.RessNr !== ressNr) || (Helper.dates.toTime(item.Day) < Helper.dates.toTime(start)) || (Helper.dates.toTime(item.Day) >= Helper.dates.toTime(end));
                    });
                    await this.schedulerRef.refresh(oldData, false);
                }
            }, addFlagToAssignments: async (flagId: string, assignmentsIds: string[]) => {
                const result = await HTTPService
                    .noBusyIndicator()
                    .post<JsonResultClass<MultiselectActionInfo[]>>("ResourcePlanningScheduler/AddFlagToAssignments", { flagId: flagId, assignmentIds: assignmentsIds });

                const oldData = this._getData()
                const events = oldData.Events;
                const updateEvents = () => {
                    const color = result.AdditionalData["color"];
                    const fontColor = result.AdditionalData["fontColor"];
                    for (let i = 0; i < events.length; i++) {
                        if (result.Data.findIndex(f => f.Id.toLowerCase() === events[i].IsGuid.toLowerCase() && f.Code === 0) > -1) {
                            if (this.props.settings.FlagMode === 2) {
                                events[i].BackgroundColor = color;
                                events[i].ForeColor = fontColor;
                            }
                            events[i].FlagId = flagId;
                        }
                    }

                    oldData.Events = events;
                    this.schedulerRef.refresh(oldData, false);
                }
                switch (result.Code) {
                    case 0:
                        updateEvents();
                        break;
                    case 1:
                        updateEvents();
                        if (this.state.multiSelectActive) {
                            await MultiselectHelper.HandleHttpResult(events, result);
                        } else {
                            NotificationHelper.showErrorMessage(result.Data[0].Message)
                        }
                        break;
                    case 2:
                        NotificationHelper.showErrorMessage(result.Message);
                        break;
                }
            }, removeFlagsFromAssignments: async (assignmentsIds: string[]) => {
                const result = await HTTPService
                    .noBusyIndicator()
                    .post<JsonResultClass<MultiselectActionInfo[]>>("ResourcePlanningScheduler/RemoveFlagsFromAssignments", { assignmentIds: assignmentsIds });
                const oldData = this._getData();
                const events = oldData.Events;
                const updateEvents = () => {
                    for (let i = 0; i < events.length; i++) {
                        if (result.Data.findIndex(f => f.Id.toLowerCase() === events[i].IsGuid.toLowerCase() && f.Code === 0) > -1) {
                            events[i].BackgroundColor = "#ffffff";
                            events[i].ForeColor = "#000000";
                        }
                    }
                    oldData.Events = events;
                    this.schedulerRef.refresh(oldData, false);
                }
                switch (result.Code) {
                    case 0:
                        updateEvents();
                        break;
                    case 1:
                        updateEvents();
                        if (this.state.multiSelectActive) {
                            await MultiselectHelper.HandleHttpResult(events, result);
                        } else {
                            NotificationHelper.showErrorMessage(result.Data[0].Message)
                        }
                        break;
                    case 2:
                        NotificationHelper.showErrorMessage(result.Message);
                        break;
                }
            }, moveAssignmentByDelta: async (assignmentId: string, delta: number) => {
                const arr = assignmentId.split("|");
                const projNr = arr[0];
                const pindex = arr[1];
                const result = await HTTPService.get<JsonResultClass<{ start: string; end: string; AssignmentUtilizationInfo: AssignmentUtilizationInfo }>>(`ResourcePlanningScheduler/MoveAssignmentByDelta?projNr=${projNr}&pIndex=${pindex}&delta=${delta}`)
                if (result.Code == 0) {
                    const oldData = this._getData();

                    const event = oldData.Events.find(event => {
                        return event.Projnr == projNr && event.Pindex.toString() == pindex;
                    })

                    event.Start = result.Data.start;
                    event.End = result.Data.end;
                    event.AssignmentUtilizationInfo = result.Data.AssignmentUtilizationInfo;

                    this.schedulerRef.partialRefresh("change", event);
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("Einsatz.VerschiebenErfolgreich"));
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            },
            changeStatusSend: async (newStatusSend: number) => {
                const events = this.state.multiSelectEvents;
                let eventIds = events.map((event) => { return event.IsGuid; });
                let result = await HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/ChangeSendState", { newStatusSend: newStatusSend, assignmentGuids: eventIds });
                if (result.Code == 0) {
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }

                const oldData = this._getData();
                const info = result.Data;
                for (let i = 0; i < this.state.multiSelectEvents.length; i++) {
                    const event = this.state.multiSelectEvents[i];
                    const index = oldData.Events.findIndex(f => f.Id == event.Id);
                    oldData.Events[index].StatusMarkingColor = info.IconColor;
                    oldData.Events[index].StatusMarkingCode = info.IconCode;
                    oldData.Events[index].SendStatus = newStatusSend;
                }

                await this.schedulerRef.refresh(oldData, false);
            },
            toggleFixedEnd: async (event) => {
                const result = await ResourcePlanningHelper.toggleFixedEnd(event);
                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.CouldntChangeFix"))
                    return;
                }
                const oldData = this._getData();
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].FixEnd = event.FixEnd ? 0 : 1;

                await this.schedulerRef.refresh(oldData, false);
            },
            toggleFixedStart: async (event) => {
                const result = await ResourcePlanningHelper.toggleFixedStart(event);
                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.CouldntChangeFix"))
                    return;
                }

                const oldData = this._getData();
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].FixStart = event.FixStart ? 0 : 1;

                await this.schedulerRef.refresh(oldData, false);
            },
            toggleFixedResource: async (event) => {
                const result = await ResourcePlanningHelper.toggleFixedResource(event);
                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(Helper.getTranslation("WebSMS.ResourcePlanningScheduler.Contextmenü.CouldntChangeFix"))
                    return;
                }

                const oldData = this._getData();
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].FixResource = event.FixResource ? 0 : 1;

                await this.schedulerRef.refresh(oldData, false);
            },
            toggleProvisional: async (event) => {
                const result = await HTTPService.post<JsonResultClass>(`ResourcePlanningScheduler/ToggleProvisional`, {
                    id: event.IsGuid,
                    settings: this.props.settings
                });

                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(result.Message)
                    return;
                }

                const colors = result.Data;

                const oldData = this._getData();
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].Provisional = !event.Provisional;
                oldData.Events[index].BackgroundColor = colors.BackgroundColor;
                oldData.Events[index].BorderColor = colors.BorderColor;
                oldData.Events[index].ForeColor = colors.FontColor;

                await this.schedulerRef.refresh(oldData, false);
            },
            toggleHalfDay: async (event) => {
                const result = await HTTPService.get<JsonResultClass>(`ResourcePlanningScheduler/ToggleHalfDay?id=${event.IsGuid}`);

                if (result.Code != 0) {
                    return;
                }

                const oldData = this._getData();
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].IsHalfDay = !event.IsHalfDay;

                await this.schedulerRef.refresh(oldData, false);
            },
            changeSendState: async (event: ResourcePlanningSchedulerEventViewModel, sendState: number) => {
                const result = await HTTPService.get<JsonResultClass>("ResourcePlanningScheduler/ChangeSendState?id=" + event.IsGuid + "&sendState=" + sendState);

                if (result.Code != 0) {
                    NotificationHelper.showErrorMessage(result.Message)
                    return;
                }

                const oldData = this._getData();
                const info = result.Data;
                const index = oldData.Events.findIndex(f => f.Id == event.Id);
                oldData.Events[index].StatusMarkingColor = info.IconColor;
                oldData.Events[index].StatusMarkingCode = info.IconCode;
                oldData.Events[index].SendStatus = sendState;

                await this.schedulerRef.refresh(oldData, false);
            },
            setContainerFilterId: (id) => {
                this.props.settings.ContainerFilterId = id;
                this.doRefresh().then();
            },
            openProject: (projNr: string) => {
                const sheet = General.Sheet.Manager.createSheetWithUrl(`Project/Edit?id=${projNr}`);
                let dataChanged = false;
                sheet.bind(SheetEventType.Close, () => {
                    if (dataChanged) {
                        this.doRefresh().then();
                    }
                });
                sheet.bind(SheetEventType.SavedSuccessfully, () => {
                    dataChanged = true;
                });

            }
        };
    private menuProps: BMenuProps = null;
    private geomapViewMode: GeomapViewMode = GeomapViewMode.None;
    //Not null after initialization
    private geomapConfig: DirectionsConfig = null;
    private readonly rightDrawerContainer: any;
    //private ignoreProjectFilterActive = false;
    private sheet: Sheet = null;
    common = new AppHelper();
    protected _dialogRef: Dialog = null;
    private listboxRef: ListBox = null;
    private factory = ComponentHelper.createFactory();
    private listTotalItems = [];
    private listRemoveItems = [];
    private listNotRemoveItems = [];
    private absenceTimeAssignment: AbsenceTimeAssignment = null;
    private suitableResourcesSearchSettings: SuitableResourceSearchSettings = null;
    protected updateIntervall: number;
    private readonly geomapRpcService: GeomapRPCService;
    private readonly openExternalInfos?: OpenExternalInfo[];
    translations: StringKeyDictionary<string>;
    workListGridOptions = {};
    workListSlotGridOptions = {};
    dropDownFilterOptions: DropDownFilterOptions = null;
    deprecatedDelphiMode: boolean = false;

    private timeResolutionTypes = {
        "Hours": 0,
        "Days": 1,
        "Week": 2,
        "Month": 3
    }
    //private refreshAfterComponentDidMount = false;
    private readonly _captionMultiSelect = null;
    private readonly _captionRessSlotFound = null;
    private readonly _captionRessSlotNotFound = null;
    private readonly _captionInteractiveSlotMode = null;

    constructor(props: ResourcePlanningSchedulerAppProps) {
        super(props);
        this.state = {
            showDialog: false,
            slotModeActive: false,
            generatedSlots: [],
            interactiveSlotModeActive: false,
            assigmentGroupingModeActive: false,
            slaModeActive: false,
            movedGroupingArray: null,
            multiSelectActive: false,
            multiSelectEvents: [],
            templateFunc: props.settings.ActiveKendoTemplate == null || props.settings.ActiveKendoTemplate.Template == null
                ? null : kendo.template(props.settings.ActiveKendoTemplate.Template),
            hintTemplateFunc: props.settings.ActiveKendoTemplate == null || props.settings.ActiveKendoTemplate.HintTemplate == null
                ? null : kendo.template(props.settings.ActiveKendoTemplate.HintTemplate),
            openInWindow: false,
            slotNotApplicableData: [],
            slotEnableDebugMode: true,
            selectedAssignmentForSlotId: null
        };
        this.common.enableHooks = true;
        this.common.init(this);
        if (Config.user.autoload === 1 && Config.user.autoloadtime !== null)
            this.updateIntervall = window.setInterval(this.checkAutomaticUpdate, (Config.user.autoloadtime ?? 30) * 1000);
        this._initData = this.props.data;
        this.settings = this.props.settings;
        this.setScreenWidth();
        this.loadDisplaySettings();
        this.loadSlotSettings();
        this.setBrowserTitle();
        let metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "translations");
        this.translations = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;
        this.rightDrawerContainer = this.props.metadata.rightDrawerContainer ? this.props.metadata.rightDrawerContainer : null;

        metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "workListGridOptions");
        this.workListGridOptions = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;

        metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "workListSlotGridOptions");
        this.workListSlotGridOptions = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;

        metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "openExternalInfo");
        this.openExternalInfos = metaDataAdditional.length > 0 ? metaDataAdditional[0].data : null;

        metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "deprecatedDelphiMode");
        this.deprecatedDelphiMode = metaDataAdditional.length > 0 ? metaDataAdditional[0].data : null;

        this.setDropDownFilterOptions();

        this.buildMenu();
        this.geomapRpcService = new GeomapRPCService("ResourcePlanning_" + kendo.guid());
        this.geomapRpcService.registerCallback("receiveRouteColors", this.receiveRouteColors);
        this._dialogActions = this.getDialogeActions();
        this._dialogActions[1].label = this.translations["Einsatz.SplitUp"];
        this._dialogActions[2].label = this.translations["Einsatz.SplitUpAndCopy"];
        this.sheet = General.Sheet.Manager.getTopMostSheet();

        this._captionMultiSelect = this.translations["WebSMS.ResourcePlanningScheduler.CaptionMultiSelect"];
        if (!Helper.hasValue(this._captionMultiSelect))
            this._captionMultiSelect = "multiselect";

        this._captionRessSlotFound = this.translations["WebSMS.ResourcePlanningScheduler.CaptionRessSlotFound"];
        if (!Helper.hasValue(this._captionMultiSelect))
            this._captionMultiSelect = "resource-for-slot found";

        this._captionRessSlotNotFound = this.translations["WebSMS.ResourcePlanningScheduler.CaptionRessSlotNotFound"];
        if (!Helper.hasValue(this._captionMultiSelect))
            this._captionMultiSelect = "no resource-for-slot found";

        this._captionInteractiveSlotMode = this.translations["WebSMS.ResourcePlanningScheduler.CaptionInteractiveSlotMode"];
        if (!Helper.hasValue(this._captionMultiSelect))
            this._captionMultiSelect = "interactive slot-mode";

        $(window).on("selectAssignmentOnInit", this.selectInitialAssignment);
        //console.log("resourcePlanningScheduler - end constructor");
    }

    private setDropDownFilterOptions = () => {

        const defaultSettings: DropDownFilterOptions = {
            maingroups: {
                url: "ResourcePlanningLookup/GetObergruppen",
                dataSourceKey: "Value",
                dataSourceText: "Name",
                template: "<table style='border-collapse:collapse; border-spacing:0; table-layout:fixed; width:125px'><colgroup><col style='width: 125px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td></tr></table>"
            },
            groups: {
                url: "ResourcePlanningLookup/GetGruppen",
                dataSourceKey: "Value",
                dataSourceText: "Name",
                template: "<table style='border-collapse:collapse; border-spacing:0; table-layout:fixed; width:125px'><colgroup><col style='width: 125px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Name}</td></tr></table>"
            },
            codes: {
                url: "ResourcePlanningLookup/GetKennungen",
                dataSourceKey: "Value",
                dataSourceText: "Name2",
                template: "<div style='width:240px;'><span style='display:inline-block;width:120px;'>${data.Name == null ? '' : data.Name}</span><span style='display:inline-block;width:120px;'>${data.Name2 == null ? '' : data.Name2}</span></div>"
            }
        }
        const metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name === "dropDownFilterOptions");
        this.dropDownFilterOptions = metaDataAdditional.length > 0 ? metaDataAdditional[0].data : defaultSettings;
        this.columnTemplate = this.props.metadata.additional.objects.find(ob => ob.name == "columnTemplate")?.data

        const checkObject = (key: string) => {
            if (!Helper.hasValue(this.dropDownFilterOptions[key])) {
                this.dropDownFilterOptions[key] = defaultSettings[key];
            } else {
                if (Helper.isNullOrEmpty(this.dropDownFilterOptions[key].url)) {
                    this.dropDownFilterOptions[key].url = defaultSettings[key].url;
                }
                if (Helper.isNullOrEmpty(this.dropDownFilterOptions[key].template)) {
                    this.dropDownFilterOptions[key].template = defaultSettings[key].template;
                }
                if (Helper.isNullOrEmpty(this.dropDownFilterOptions[key].dataSourceKey)) {
                    this.dropDownFilterOptions[key].dataSourceKey = defaultSettings[key].dataSourceKey;
                }
                if (Helper.isNullOrEmpty(this.dropDownFilterOptions[key].dataSourceText)) {
                    this.dropDownFilterOptions[key].dataSourceText = defaultSettings[key].dataSourceText;
                }

            }
        }
        Object.keys(defaultSettings).forEach(checkObject)
    }

    private checkAutomaticUpdate = async () => {
        if (!this.state.interactiveSlotModeActive) {
            const result = await createHtppServiceInstance().noBusyIndicator().get("ResourcePlanningScheduler/CheckUpdateScheduler");
            if (result.Data === true) {
                await this.doRefresh(null, 0, false);
            }
        }
    }

    private setScreenWidth = () => {
        if (Helper.isNullOrEmpty(this.props.settings.FavoriteFilterId)) {
            const fitToScreen: boolean = Helper.loadDataFromStorage("timeSpanManager_fitToScreen");
            if (Helper.hasValue(fitToScreen)) {
                this.settings.FixedCellWidth = !fitToScreen;
            } else {
                this.settings.FixedCellWidth = false;
            }
        } else {
            this.settings.FixedCellWidth = this.props.settings.FixedCellWidth;
        }
    }


    private loadSlotSettings = () => {
        let ds: ResourcePlanningSchedulerSlotSettings =
            Helper.loadDataFromStorage("resourcePlanningScheduler_SlotSettings");

        if (ds !== undefined) {
            this.slotSearchSettings.slotEnableDebugMode = Helper.getValueOrDefault(ds.SlotEnableDebugMode, true);
            this.slotSearchSettings.slotRespectSlotResourceFilter = Helper.getValueOrDefault(ds.SlotRespectSlotResourceFilter, true);
            this.slotSearchSettings.considerFlags = Helper.getValueOrDefault(ds.ConsiderFlags, false);
            this.slotSearchSettings.considerGroup = Helper.getValueOrDefault(ds.ConsiderGroup, false);
            this.slotSearchSettings.considerSkills = Helper.getValueOrDefault(ds.ConsiderSkills, false);
            this.slotSearchSettings.considerMainGroup = Helper.getValueOrDefault(ds.ConsiderMainGroup, true);
            this.slotSearchSettings.considerGeo = Helper.getValueOrDefault(ds.ConsiderGeo, true);
            this.slotSearchSettings.considerSla = Helper.getValueOrDefault(ds.ConsiderSla, false);

            if (!this.settings.SkillsEnabled)
                this.slotSearchSettings.considerSkills = ConsiderSkillMode.Off;
            if (!Config.settings.flagsAreActive)
                this.slotSearchSettings.considerFlags = false;
            if (!Config.user.slaManagementRight)
                this.slotSearchSettings.considerSla = false;
        }
    }

    private saveSlotSettings = () => {
        let ds: ResourcePlanningSchedulerSlotSettings = {
            SlotRespectSlotResourceFilter: this.slotSearchSettings.slotRespectSlotResourceFilter,
            SlotEnableDebugMode: this.slotSearchSettings.slotEnableDebugMode,
            ConsiderFlags: this.slotSearchSettings.considerFlags,
            ConsiderMainGroup: this.slotSearchSettings.considerMainGroup,
            ConsiderGroup: this.slotSearchSettings.considerGroup,
            ConsiderSkills: this.slotSearchSettings.considerSkills,
            ConsiderGeo: this.slotSearchSettings.considerGeo,
            ConsiderSla: this.slotSearchSettings.considerSla
        }
        Helper.saveDataToStorage("resourcePlanningScheduler_SlotSettings", ds, false);
    }

    // noinspection JSUnusedLocalSymbols
    private loadExtendedProjectFilter = (settings: any) => {
        if (Config.user.activeExtendedProjectFilter) {
            let extProjFilter: ProjectFilterHistoryItem[] = Helper.loadDataFromStorage(Config.user.userName + "_ExtProjFilter");
            if (extProjFilter) {
                if (settings.FavoriteFilterId != null) {
                    extProjFilter.forEach(e => {
                        e.Active = false;
                    });
                }
                settings.ProjNrs = extProjFilter.filter(h => h.Active).map(h => h.ProjNr).concat(settings.ProjNrs);
                settings.ProjNrsHistory = extProjFilter;
            }
        }
    }
    private loadDisplaySettings = () => {
        if (!Helper.isNullOrEmpty(this.props.settings.FavoriteFilterId)) {
            return
        }

        let ds: ResourcePlanningSchedulerDisplaySettings =
            Helper.loadDataFromStorage("resourcePlanningScheduler_DisplaySettings");

        if (ds !== undefined) {
            this.settings.AssignmentMoveHorizontalFixed = ds.AssignmentMoveHorizontalFixed;
            this.settings.AssignmentMoveVerticalFixed = ds.AssignmentMoveVerticalFixed;
            this.settings.ShowAssignmentsWithTimeZones = ds.ShowAssignmentsWithTimeZones;
            this.settings.ShowProjectColor = ds.ShowProjectColor;
            this.settings.FlagMode = ds.FlagMode;
            this.settings.ShowOnlyWorktime = this.props.settings.AllWeekendDays.length == 0 ? ds.ShowOnlyWorktime : false;
            this.settings.GroupByResources = ds.GroupByResources;
            this.settings.GroupByAddresses = ds.GroupByAddresses;
            this.settings.GroupByProjects = ds.GroupByProjects;
            this.settings.GroupByMachines = ds.GroupByMachines;

            if (this.settings.GroupByResources === undefined && this.settings.GroupByAddresses === undefined && this.settings.GroupByProjects === undefined && this.settings.GroupByMachines === undefined) {
                this.settings.GroupByResources = true;
                this.settings.GroupByAddresses = false;
                this.settings.GroupByProjects = false;
                this.settings.GroupByMachines = false;
            }

            this.settings.DisplayCapacityChart = ds.DisplayCapacityChart;
            this.settings.DisplayGeomapMap = (ds.DisplayGeomapMap && this.props.settings.Geomap_Enabled);
            this.settings.DisplayWorkListInTable = ds.DisplayWorkListInTable;
            this.settings.WholeDayAssignmentRendering = (Helper.getValueOrDefault(ds.WholeDayAssignmentRendering, false) && this.props.settings.TimeResolutionType === this.timeResolutionTypes.Days);
            this.settings.SlaViewActive = ds.SlaViewActive && !ds.AssignmentGroupingViewActive;
            this.settings.ShowUtilization = (Helper.getValueOrDefault(ds.ShowUtilization, false) && (this.props.settings.TimeResolutionType === this.timeResolutionTypes.Hours || this.props.settings.TimeResolutionType === this.timeResolutionTypes.Days));
            this.settings.ShowTargetPeriods = Helper.getValueOrDefault(ds.ShowTargetPeriods, false);
            this.settings.ShowDegreeOfCompletion = Helper.getValueOrDefault(ds.ShowDegreeOfCompletion, false);
            this.settings.AssignmentGroupingViewActive = this.props.settings.AssignmentGroupingActive && ds.AssignmentGroupingViewActive && !ds.SlaViewActive;

            this.settings.CapacityIgnoreProjectFilter = ds.CapacityIgnoreProjectFilter;
            this.settings.ProjectFilterShowAllAssignments = false; // ds.ProjectFilterShowAllAssignments;
        }

        //if (this.settings.ShowAssignmentsWithTimeZones || this.settings.ShowProjectColor || this.settings.GroupByProjects || this.settings.FlagMode > 0 || this.settings.GroupByMachines || this.settings.GroupByAddresses)
        //    this.refreshAfterComponentDidMount = true;
    }

    private saveDisplaySettings = () => {
        if (!Helper.isNullOrEmpty(this.props.settings.FavoriteFilterId))
            return;

        let ds: ResourcePlanningSchedulerDisplaySettings = {
            AssignmentMoveHorizontalFixed: this.settings.AssignmentMoveHorizontalFixed,
            AssignmentMoveVerticalFixed: this.settings.AssignmentMoveVerticalFixed,
            ShowAssignmentsWithTimeZones: this.settings.ShowAssignmentsWithTimeZones,
            ShowProjectColor: this.settings.ShowProjectColor,
            FlagMode: this.settings.FlagMode,
            ShowOnlyWorktime: this.settings.ShowOnlyWorktime,
            GroupByResources: this.settings.GroupByResources,
            GroupByAddresses: this.settings.GroupByAddresses,
            GroupByProjects: this.settings.GroupByProjects,
            GroupByMachines: this.settings.GroupByMachines,
            DisplayCapacityChart: this.settings.DisplayCapacityChart,
            DisplayGeomapMap: this.settings.DisplayGeomapMap,
            DisplayWorkListInTable: this.settings.DisplayWorkListInTable,
            WholeDayAssignmentRendering: this.settings.WholeDayAssignmentRendering,
            SlaViewActive: this.settings.SlaViewActive,
            ShowUtilization: this.settings.ShowUtilization,
            ShowTargetPeriods: this.settings.ShowTargetPeriods,
            ShowDegreeOfCompletion: this.settings.ShowDegreeOfCompletion,
            AssignmentGroupingViewActive: this.settings.AssignmentGroupingViewActive,
            CapacityIgnoreProjectFilter: this.settings.CapacityIgnoreProjectFilter,
            ProjectFilterShowAllAssignments: this.settings.ProjectFilterShowAllAssignments
        }

        Helper.saveDataToStorage("resourcePlanningScheduler_DisplaySettings", ds, false);
    }

    private buildMenu = () => {
        this.menuProps = {
            enableMenuItem: (item) => {
                if (typeof item === "boolean") {
                    return item;
                }
                else if (item === "_enableGeomap") {
                    return this.props.settings.Geomap_Enabled;
                }
                else if (item === "_enableCapacity") {
                    return true;
                }
                else if (item === "_enableCapacityFilter") {

                    return Helper.hasValue(this.schedulerRef) && this.schedulerRef.state.capacityIsOn;
                }
                else if (item === "_enableCapacitySelectAll") {
                    return Helper.hasValue(this.schedulerRef) && this.schedulerRef.state.capacityIsOn;
                }
                else if (item === "_enableCapacitySelectNone") {
                    return Helper.hasValue(this.schedulerRef) && this.schedulerRef.state.capacityIsOn;
                }
                else if (item === "_enableGeomap && _enableGeomapViewInPB") {
                    return this.props.settings.Geomap_Enabled && this.geomapViewMode !== GeomapViewMode.StandardView;
                }
                else if (item === "_enableGeomap && _enableResourceViewInPB") {
                    return this.props.settings.Geomap_Enabled && this.props.settings.GroupByResources && this.geomapViewMode !== GeomapViewMode.ResourceView;
                }
                else if (item === "_enableGeomap && _enableHidePBView") {
                    return this.props.settings.Geomap_Enabled && this.geomapViewMode !== GeomapViewMode.None;
                }
                else if (item === "_enableGeomap && _enableResourceViewInTab") {
                    return this.props.settings.Geomap_Enabled && this.props.settings.GroupByResources;
                }
                else if (item === "_enableGeomap && _enableGeomapViewInTab") {
                    return this.props.settings.Geomap_Enabled && this.props.settings.GroupByResources;
                }
                else if (item === "_exportDiagramExcel") {
                    return this.props.settings.DisplayCapacityChart;
                }

                return true;
            },
            entries: [
                {
                    text: this.translations["Kapazitaet.Filter"],
                    onClick: "capacityFilter",
                    show: "_enableCapacityFilter",
                },
                {
                    text: this.translations["Kapazitaet.SelectAll"],
                    onClick: "capacitySelectAll",
                    show: "_enableCapacitySelectAll",
                },
                {
                    text: this.translations["Kapazitaet.SelectNone"],
                    onClick: "capacitySelectNone",
                    show: "_enableCapacitySelectNone",
                },
                {
                    text: this.translations["GeoMap.GeomapViewInPB"],
                    onClick: "geomapViewInPB",
                    show: "_enableGeomap && _enableGeomapViewInPB",
                    inContext: true
                },
                {
                    text: this.translations["GeoMap.ResourceViewInPB"],
                    onClick: "resourceViewInPB",
                    show: "_enableGeomap && _enableResourceViewInPB",
                    inContext: true
                },
                {
                    text: this.translations["GeoMap.GeomapViewInTab"],
                    onClick: "geomapViewInTab",
                    show: "_enableGeomap && _enableGeomapViewInTab",
                    inContext: true
                },
                {
                    text: this.translations["GeoMap.ResourceViewInTab"],
                    onClick: "resourceViewInTab",
                    show: "_enableGeomap && _enableResourceViewInTab",
                    inContext: true
                },
                {
                    text: this.translations["GeoMap.HidePBView"],
                    onClick: "hidePBView",
                    show: "_enableGeomap && _enableHidePBView",
                    inContext: true
                },
                {
                    text: this.translations["WebSMS.ResourcePlanningScheduler.ExportToImage"],
                    onClick: "printScheduler",
                    show: true,
                    inContext: true
                },
                {
                    text: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ExportToExcel"),
                    onClick: "exportDiagramExcel",
                    show: "_exportDiagramExcel",
                    inContext: true
                }
            ],
            onSelect: (action) => {
                const doOnSelect = async () => {
                    if (action === "geomapViewInTab") {
                        this.prepareGeomapConnection();
                        Helper.openInNewBrowserTab(Config.baseUrl + "Directions?frompb=true");
                    }
                    else if (action === "resourceViewInTab") {
                        let parameters = await this.getGeomapParameters();
                        if (parameters) {
                            this.prepareGeomapConnection();
                            Helper.openInNewBrowserTab(Config.baseUrl + "Directions?type=resourceRoutes&frompb=true" + parameters.dateParameters + parameters.parameterString);
                        }
                    }
                    else if (action === "geomapViewInPB") {
                        this.geomapViewMode = GeomapViewMode.StandardView;
                        if (this.geomapConfig != null) {
                            this.geomapConfig = null;
                            this.setState({ geomapRouteColors: null }, () => {
                                this.openInPlanningBoard();
                                this.schedulerRef.getDps().update();
                            });
                        }
                        else {
                            this.openInPlanningBoard();
                        }
                    }
                    else if (action === "resourceViewInPB") {
                        await this.setResourceViewInPb();
                    }
                    else if (action === "hidePBView") {
                        this.geomapViewMode = GeomapViewMode.None;
                        this.geomapConfig = null;
                        this.props.settings.DisplayGeomapMap = false;
                        this.saveDisplaySettings();
                        this.setState({ geomapRouteColors: null }, this.schedulerRef.getDps().update);
                    } else if (action === "capacityFilter") {
                        this.schedulerRef.refreshCapacity(CapacityRefreshMode.ApplyFilter);
                    } else if (action === "capacitySelectAll") {
                        this.schedulerRef.selectAllResources();
                    } else if (action === "capacitySelectNone") {
                        this.schedulerRef.deselectAllResources();
                    } else if (action === "printScheduler") {
                        this.printScheduler();
                    } else if (action === "exportDiagramExcel") {
                        this.schedulerRef.getCapacityDiagram().exportDiagramToExcel();
                    }
                };

                doOnSelect().then();
            },
            handleEval: this.common.evalAction
        };
    }

    private handleChangeFilterField = async (field: { model: keyof ResourcePlanningSchedulerSettingsViewModel } | Array<{ model: keyof ResourcePlanningSchedulerSettingsViewModel }>, value: any | Array<any>, setSchedulertoStartDate: boolean = false) => {
        const updateSingleField = (single: { model: keyof ResourcePlanningSchedulerSettingsViewModel }, value: Date) => {
            if (Helper.hasValue(single)) {
                if (value instanceof Date)
                    this.settings[single.model] = kendo.toString(value, "d") as never;
                else
                    this.settings[single.model] = value as never;
            }
        }
        if (Config.user.activeExtendedProjectFilter) {
            if ((Array.isArray(field) && field.filter((f: { model: keyof ResourcePlanningSchedulerSettingsViewModel }) => f.model === "FavoriteFilterId").length > 0) ||
                (!Array.isArray(field) && field.model === "FavoriteFilterId")) {
                this.settings["ActiveExtendedProjectFilter"] = this.settings.ActiveExtendedProjectFilter;
            }
            const extendedProjFilter = Helper.loadDataFromStorage(Config.user.userName + "_ExtProjFilter");
            if (extendedProjFilter) {
                let projNrs = extendedProjFilter.filter((e: any): any => e.Active).map((e: any): any => e.ProjNr);
                if (Array.isArray(field)) {
                    let index = field.findIndex(f => f.model === "FavoriteFilterId");
                    if (index > -1 && value.length > index && !Helper.hasValue(value[index])) {
                        if (Helper.hasValue(this.props.settings.FavoriteFilterId)) {
                            const result = await HTTPService.get<JsonResultClass<FavoriteFilter[]>>("FavoriteFilter/GetAllForUser");
                            if (result.Code !== 0)
                                NotificationHelper.showErrorMessage(result.Message);
                            NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.DeactivateFavoriteFilter").replace("{filterName}", result.Code === 0 ? result.Data.find(f => f.Id === this.props.settings.FavoriteFilterId).Name : "???"));
                        }
                        field.push({ model: "ProjNrs" });
                        value.push(projNrs);
                        field.push({ model: "ProjNrsHistory" });
                        value.push(extendedProjFilter);
                    } else if (index > -1 && value.length > index && Helper.hasValue(value[index]) && projNrs.length > 0) {
                        NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ProjNrsDeactivated"));
                    }
                } else if (field.model === "FavoriteFilterId") {
                    if (!Helper.hasValue(value)) {
                        if (Helper.hasValue(this.props.settings.FavoriteFilterId)) {
                            const result = await HTTPService.get<JsonResultClass<FavoriteFilter[]>>("FavoriteFilter/GetAllForUser");
                            if (result.Code !== 0)
                                NotificationHelper.showErrorMessage(result.Message);
                            NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.DeactivateFavoriteFilter").replace("{filterName}", result.Code === 0 ? result.Data.find(f => f.Id === this.props.settings.FavoriteFilterId).Name : "???"));
                        }
                        let newFields: Array<{ model: keyof ResourcePlanningSchedulerSettingsViewModel }> = [];
                        let newValues: Array<any> = [];
                        newFields.push(field);
                        newValues.push(value);
                        newFields.push({ model: "ProjNrs" });
                        newValues.push(projNrs);
                        newFields.push({ model: "ProjNrsHistory" });
                        newValues.push(extendedProjFilter);
                        field = newFields;
                        value = newValues;
                    } else if (projNrs.length > 0) {
                        NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ProjNrsDeactivated"));
                    }
                }
            }
        }

        if (Array.isArray(field)) {
            field.forEach((x, i) => updateSingleField(x, value[i]));
        } else {
            updateSingleField(field, value);
        }

        this.saveDisplaySettings();

        //if (this.settings.AutomaticUpdate) 
        {
            let resetXPos: boolean
            if (Object.keys(field).findIndex(f => f === 'model') > -1) {
                resetXPos = (field as any).model == 'SelectedFilterGuid';
            } else {
                resetXPos = (field as any).findIndex((f: { model: string; }) => f.model == "SelectedFilterGuid") > -1;
            }
            await this.doRefresh(null, 0, true, resetXPos);
        }
        /*else
            if ((field as any).model == "SelectedFilterGuid") { // Wenn kein AU und Filter geändert wurde -> nur Filtereinstellungen aktualisieren ohne refresh der Plantafel
                await HTTPService.get<JsonResultClass>("ResourcePlanningScheduler/GetFilter", { guid: value })
            }*/
        //todo: check this!!
        this.setState({}, () => {
            const targetField = Array.isArray(field) ? field.filter(x => x.model === "ProjNrs")[0] : field;
            if (Helper.hasValue(targetField) && targetField.model === "ProjNrs") {
                if (this.settings.ProjNrs.length === 0)
                    this.actions.signalIgnoreProjectFilterInCapacity(false, true);
                else
                    this.setConsiderHiddenAssignmentsForCapacity();
            }

            const startField = Array.isArray(field) ? field.filter(x => x.model === "Start")[0] : field;
            const endField = Array.isArray(field) ? field.filter(x => x.model === "End")[0] : field;

            if (Helper.hasValue(startField) || Helper.hasValue(endField)) {
                this.schedulerRef.dropCapacityDiagramAwaitTrigger();
                if (setSchedulertoStartDate) {
                    this.schedulerRef.scrollToStart();
                }
            }
        });
    }

    private reloadFlags = async () => {
        const result = await HTTPService.get<JsonResultClass>("PlanningBoardFlag/GetAllFlags");
        this.settings.Flags = result.Data;
    }

    private setDialogRef = (r: Dialog) => {
        this._dialogRef = r;
    }

    private setListBoxRef = (r: ListBox) => {
        this.listboxRef = r;
    }
    private openDialog = () => {
        this.setState({
            showDialog: true,
        });
    }

    private closeDialog = () => {
        this.setState({
            showDialog: false
        });
    }

    private fragmentCopyAssignment = async (copyToContainer: boolean) => {
        const items = this.listboxRef.getItems();
        const itemsRight = items.right;
        let arrProjnr = [];
        let arrPindex = [];
        for (let i = 0; i < itemsRight.length; i++) {
            arrProjnr.push(itemsRight[i].ProjNr);
            arrPindex.push(itemsRight[i].Pindex);
        }
        const result = await HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/FragmentationCopyAssignment",
            {
                projnr: arrProjnr,
                pindex: arrPindex,
                startIstFehl: this.absenceTimeAssignment.StartIst,
                endeIstFehl: this.absenceTimeAssignment.EndeIst, copyToContainer: copyToContainer
            })
        if (result.Code === 1) {
            NotificationHelper.showErrorMessage(result.Message);
        }
        else if (result.Code === 2) {
            NotificationHelper.showWarningMessage(result.Message);
        }
        else {
            NotificationHelper.showSuccessMessage(result.Message);
        }
        await this.doRefresh();
        this.closeDialog();
    }

    private getDialogeActions = (): Array<DialogAction> => {
        return [
            {
                label: Config.translations.ignore,
                action: () => {
                    this.closeDialog();
                },
            },
            {
                label: this.translations["Einsatz.SplitUp"],
                action: () => {
                    this.fragmentCopyAssignment(false).then();

                },
                cancel: true
            },
            {
                label: this.translations["Einsatz.SplitUpAndCopy"],
                action: () => {
                    this.fragmentCopyAssignment(true).then();
                }
            },
            {
                label: Config.translations.apply,
                action: () => {
                    const items = this.listboxRef.getItems();
                    const itemsRight = items.right;
                    const moveInstances: Array<HTTPRequestConfig> = [];
                    for (let i = 0; i < itemsRight.length; i++) {
                        moveInstances.push({
                            url: "ResourcePlanningScheduler/MoveAssignment",
                            type: HTTPRequestType.Post,
                            data: {
                                projNr: itemsRight[i].ProjNr,
                                pIndex: itemsRight[i].Pindex,
                                settings: this.props.settings,
                                newStart: itemsRight[i].StartIst,
                                newEnd: itemsRight[i].EndeIst,
                                newResourceId: "g|" + itemsRight[i].GrNr,
                                oldResourceId: "r|" + itemsRight[i].RessNr,
                                resizeAction: false,
                                slot: null,
                                byDelta: false
                            }
                        });
                    }
                    if (moveInstances.length > 1) {
                        HTTPService.batch(...moveInstances).then((result) => {
                            let error = false;
                            for (let j = 0; j < result.length; j++) {
                                if (result[j].Code > 0) {
                                    error = true;
                                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlanning.ProjektNichtVerschoben"] + " " + itemsRight[j].ProjNr + "/" + String(itemsRight[j].Pindex));
                                }
                            }
                            if (!error && (result.length > 0)) {
                                NotificationHelper.showSuccessMessage(result[0].Message);
                            }
                            this.doRefresh().then();
                        });
                    }
                    else if (moveInstances.length > 0) {
                        HTTPService.post<JsonResultClass>(moveInstances[0].url, moveInstances[0].data)
                            .then(result => {
                                if (result.Code > 0) {
                                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlanning.ProjektNichtVerschoben"] + " " + itemsRight[0].ProjNr + "/" + String(itemsRight[0].Pindex));
                                }
                                else {
                                    NotificationHelper.showSuccessMessage(result.Message);
                                }
                                this.doRefresh().then();

                            });
                    }

                    this.closeDialog();
                },
                primary: true

            }];
    }
    // Start events scheduler
    private handleSelectedResourceChanged = (resourceId: string, selected: boolean) => {
        if (selected && Helper.hasValue(resourceId))
            this.scrollToSlotDebugInfo(resourceId);

        if (this.geomapViewMode !== GeomapViewMode.ResourceView && selected) {
            this.setStandardRoute(resourceId);
        }
        else {
            this.setOrRemoveRouteMarking(resourceId, selected);
        }
    }

    private handleSelectedEventChanged = (eventId: string, isDifferentEvent?: boolean, slot?: ResourceSlot) => {
        //todo: hmmm .. 
        this.setState({});
        if (eventId && isDifferentEvent) {
            if (slot) {
                this.setSlotStandardRoute(slot);
            } else {
                this.setAssignmentAsStandardRoute(eventId);
            }
        }
    }

    private handleSelectedTimeRangeChanged = (resourceId: string, date: Date) => {
        this.scrollToSlotDebugInfo(resourceId, date);
    }

    // private handlePartialRefresh = (type: "add" | "change" | "remove", event: ResourcePlanningSchedulerEventViewModel) => {
    private handlePartialRefresh = (type: "add" | "change" | "remove", event: ResourcePlanningSchedulerEventViewModel) => {
        //1. selection
        if (type == "add" || type == "change")
            this.schedulerRef.markEvent(event.Id);
        else
            this.schedulerRef.clearMarkedEvent();

        //2. geomap
        this.refreshGeomap([event.ResourceId]).then();

        //3. update slots
        this.updateWorklist();
    }

    private updateWorklist = (doRefreshGrid: boolean = true, doClearSelection: boolean = false) => {
        if (this.workListRef !== null) {
            let id = this.getSlotModeSourceId();
            if (doClearSelection)
                id = null;
            //console.log("updateWorklist: id=" + id);
            //refresh grid
            if (this.workListRef !== null && doRefreshGrid) {

                this.workListRef.refreshGrids();
            }

            //select row
            if (id != null) {
                //slot mode active -> update slots 
                this.actions.slotWorkListChanged();
            }
            else {
                let markedEvent = this.schedulerRef.getMarkedEvent();
                if (markedEvent !== null && this.workListRef !== null)
                    this.workListRef.selectRow(markedEvent.Id);
                if (id == null && this.state.slotModeActive)
                    this.setState({ slotModeActive: false, generatedSlots: [], selectedAssignmentForSlotId: null },
                        () => { this.schedulerRef.refresh(this._getData(), false).then(); });
            }

            if (!this.state.interactiveSlotModeActive || (id == null /* && this.state.slotModeActive */)) {
                this.workListRef.setState({ showSlotsGrid: false });
            }
        }
    }
    // End events scheduler

    // Start actions
    copyToResources = (id: string) => {
        let arr = id.split("|");
        let url = "DynamicSearch/Window/Resource?withSkills=true&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus&multi=true&displayPattern=[[name]] [[vorname]]";
        if (Helper.hasValue(arr) && arr.length >= 2)
            url = url + `&projnr=${encodeURIComponent(arr[0])}&pindex=${encodeURIComponent(arr[1])}`;
        let index = Helper.findIndex(this._getData().Events, "Id", id);
        let event = this._getData().Events[index];
        if (Helper.hasValue(event.IsGuid)) {
            url += "&eventIsGuids=" + event.IsGuid;
        }
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<any> }) => {
            const ressourceIds = [];
            e.data.forEach(data => {
                ressourceIds.push("r|" + data.ressnr);
            });
            if (ressourceIds.length > 0) {
                const copyGrouped = this.props.settings.AssignmentGroupingActive && this.props.settings.CopyRessourceGroupingActive &&
                    await ResourcePlaningGroupingHelper.checkCopyGrouped(
                        event.Projnr, event.Pindex, event.ResourceId, event.Gruppierung, ressourceIds);

                HTTPService.post<JsonResultClass>("ResourcePlanning/CopyAssignment", {
                    projNr: arr[0],
                    pIndex: arr[1],
                    newResourceIds: ressourceIds,
                    copyGrouped: copyGrouped
                }).then(result => {
                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                    this.doRefresh().then()
                });
            }
        });
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    private doRefresh = async (projNr: string = null, pIndex: number = 0, busyIndicator: boolean = true, autoScroll: boolean = true, favFilterChanged: boolean = false) => {

        if (this.lastCancelToken) {
            this.lastCancelToken.cancel();
            this.lastCancelToken = null;
        }
        
        const currentToken = axios.CancelToken.source();
        this.lastCancelToken = currentToken;


        //increment
        if (busyIndicator) HTTPService.requestStart(this.schedulerRef.getPilotDiv());

        axios.post<JsonResultClass<ResourcePlanningSchedulerDataViewModel>>(Config.baseUrl + "ResourcePlanningScheduler/GetData", { settings: this.props.settings }, { cancelToken: currentToken.token })
            .then((result) => {
                if (this.lastCancelToken == currentToken) {
                    if (result.data.Code === 0) {
                        let newData = result.data.Data;
                        this.settings.Start = newData.SettingsPlanningBoard.Start;
                        this.settings.End = newData.SettingsPlanningBoard.End;

                        this.setState({ multiSelectEvents: [], movedGroupingArray: null }, async () => {
                            await this.schedulerRef.refresh(newData, false, async () => {
                                //1. selection 
                                this.sheet.trigger(SheetEventType.Custom, { type: "schedulerDataLoaded" });
                                if (projNr != null && !this.state.multiSelectActive) {
                                    this.schedulerRef.markEvent(projNr + "|" + pIndex);
                                } else
                                    this.schedulerRef.clearMarkedEvent();
                                //2. refresh geomap
                                let ressId = null;
                                if (projNr != null) {
                                    const ev = this.getEvent(projNr + "|" + pIndex);
                                    if (ev != null)
                                        ressId = ev.ResourceId;
                                }
                                await this.refreshGeomap(ressId != null ? [ressId] : []);
                                //3. refresh slots
                                this.updateWorklist();

                                //4. autoscroll
                                const viewPort = this.schedulerRef.getDps().getViewPort();
                                if (autoScroll && Helper.hasValue(viewPort)) {
                                    this.schedulerRef.getDps().scrollTo(viewPort.start);
                                }

                                //5. kapa select
                                if (favFilterChanged) {
                                    this.actions.toggleCapacity(this.props.settings.DisplayCapacityChart);
                                    this.actions.signalIgnoreProjectFilterInCapacity(this.props.settings.CapacityIgnoreProjectFilter, false);
                                    this.actions.toggleSlaView(this.props.settings.SlaViewActive, false);
                                }

                                if (favFilterChanged && this.settings.DisplayCapacityChart) {
                                    setTimeout(() => {
                                        this.schedulerRef.selectAllResources();
                                        this.schedulerRef.refreshCapacity(CapacityRefreshMode.ApplyFilter);
                                    }, 0)
                                }
                                this._refreshing = false;
				                this._forceUpdate = true;
                                this.onFocusingChange(this.focusing.searchType, this.focusing.value);

                                //decrement 
                                if (busyIndicator) HTTPService.requestEnd(this.schedulerRef.getPilotDiv());
                            });
                        });
                    } else {
                        NotificationHelper.showErrorMessage(result.data.Message);
                        if (busyIndicator)
                            HTTPService.requestEnd();
                        this.setState({ multiSelectEvents: [], movedGroupingArray: null });
                    }
                } else {
                    //decrement 
                    if (busyIndicator) HTTPService.requestEnd(this.schedulerRef.getPilotDiv());
                }
            }).catch((err: any) => {
                if (this.lastCancelToken == currentToken) {
                    NotificationHelper.showErrorMessage(err);
                }
                //decrement 
                if (busyIndicator) HTTPService.requestEnd(this.schedulerRef.getPilotDiv());
            });
    }

    splitToResources = (id: string) => {
        let arr = id.split("|");
        let url = "DynamicSearch/Window/Resource?withSkills=true&cus_disableRECHTPE=true&cus_disablePERSONALDATENRECHT=true&resstatus=0%20or%20null&disabled=resstatus&multi=true&displayPattern=[[name]] [[vorname]]";
        if (Helper.hasValue(arr) && arr.length >= 2)
            url = url + `&projnr=${encodeURIComponent(arr[0])}&pindex=${encodeURIComponent(arr[1])}`;
        let index = Helper.findIndex(this._getData().Events, "Id", id);
        let event = this._getData().Events[index];
        if (Helper.hasValue(event.IsGuid)) {
            url += "&eventIsGuids=" + event.IsGuid;
        }
        const sheet = General.Sheet.Manager.createSheetWithUrl(url);
        sheet.bind(SheetEventType.ItemsSelected, async (e: { data: Array<any> }) => {
            let ressNrs = [];
            e.data.forEach(data => {
                ressNrs.push("r|" + data.ressnr);
            });
            if (ressNrs.length > 0) {
                let result = await HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/SplitAssignment", {
                    projNr: arr[0],
                    pIndex: arr[1],
                    settings: this.props.settings,
                    newResourceIds: ressNrs
                });
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
                await this.doRefresh();
            }
        });
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }

    private deleteEvent = async (id: string) => {
        let arr = id.split("|");
        let index = Helper.findIndex(this._getData().Events, "Id", id);
        let event = this._getData().Events[index];
        let assignmentDeleted = (multiple: boolean) => {
            if (this.props.settings.AutoUpdateScheduler || multiple) {
                this.doRefresh();
            }
            else {
                this.schedulerRef.partialRefresh("remove", event);
            }
        }
        await OpenResourcePlanningDeletionDialog({ ...event, ProjNr: arr[0], PIndex: parseInt(arr[1]) }, assignmentDeleted)
    }

    private copyEvent = async (id: string, newStart: Date, newEnd: Date, newResourceId: string) => {
        if (!this.checkIfProjectForbidsEditing(id)) {
            let arr = id.split("|");
            let arrResourceId = newResourceId.split("|");
            if (arrResourceId[0] == "r") {
                let checkSkills = await ResourcePlanningHelper.checkSkills(arr[0], Number(arr[1]), arrResourceId[1], Helper.getTranslation("WebSMS.ResourcePlanning.CheckSkillsNegativCopy"));
                if (!checkSkills)
                    return;
            }

            const event = this._getEventById(id);
            const copyGrouped = this.props.settings.AssignmentGroupingActive && this.props.settings.CopyRessourceGroupingActive &&
                await ResourcePlaningGroupingHelper.checkCopyGrouped(
                    event.Projnr, event.Pindex, event.ResourceId, event.Gruppierung, [newResourceId]);

            HTTPService.post<JsonResultClass<CopiedAssignmentInfo[]>>(
                "ResourcePlanningScheduler/CopyAssignment",
                { projNr: arr[0], pIndex: arr[1], settings: this.props.settings, newStart: Helper.dates.getISODateString(newStart), newEnd: Helper.dates.getISODateString(newEnd), newResourceId: newResourceId, copyGrouped: copyGrouped })
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.settings.AutoUpdateScheduler || result.Data[0].eventEntity === null) {
                            this.doRefresh(result.Data[0].projNr, result.Data[0].pIndex);
                        }
                        else {
                            result.Data.forEach(p => {
                                this.schedulerRef.partialRefresh("add", p.eventEntity);
                            })
                        }
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private splitEvent = async (id: string, newResourceId: string) => {
        if (!this.checkIfProjectForbidsEditing(id)) {
            let arr = id.split("|");
            let arrResourceId = newResourceId.split("|");
            if (arrResourceId[0] == "r") {
                let checkSkills = await ResourcePlanningHelper.checkSkills(arr[0], Number(arr[1]), arrResourceId[1], Helper.getTranslation("WebSMS.ResourcePlanning.CheckSkillsNegativCopy"));
                if (!checkSkills)
                    return;
            }
            HTTPService.post<JsonResultClass>(
                "ResourcePlanningScheduler/SplitAssignment",
                { projNr: arr[0], pIndex: arr[1], settings: this.props.settings, newResourceIds: [newResourceId] })
                .then(result => {
                    if (result.Code === 0) {
                        if (this.props.settings.AutoUpdateScheduler || result.Data[0].eventEntity === null) {
                            this.doRefresh(result.Data[0].projNr, result.Data[0].pIndex);
                        }
                        else {
                            this.schedulerRef.partialRefresh("add", result.Data[1].eventEntity, false);
                            this.schedulerRef.partialRefresh("change", result.Data[0].eventEntity);
                            //k/a wie so, aber wird Geomap mit newRessourceId aktualisiert
                            this.refreshGeomap([newResourceId]);
                        }
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        }
    }

    private checkIfProjectForbidsEditing = (id: string) => {
        let index = Helper.findIndex(this._getData().Events, "Id", id);
        let event = this._getData().Events[index];
        let result = false;
        if (event != null) {
            try {
                result = (event.ProjectStatus.Planung === 2) || (this.props.settings.AssignmentEditingTiedToProjectStatus && event.ProjectStatus.Planung === 0);
                if (event.ProjectStatus.Planung === 2) {
                    NotificationHelper.showInfoMessage(this.translations["Einsatz.ProjectEditingLocked"].replace("{ProjNr}", id.split("|")[0]))
                } else if (this.props.settings.AssignmentEditingTiedToProjectStatus && event.ProjectStatus.Planung === 0) {
                    NotificationHelper.showInfoMessage(this.translations["WebSMS.ResourcePlanning.NoEditingCauseStatus"]);
                }
            } catch {
                //weil kein bock mehr hatte 
            }
        }
        return result;
    }

    public async asyncGroupDialog(projNr: string, pIndex: number, newStart: Date, newEnd: Date, groupings: Array<number>,
        assignmentsNoGrouping: Array<AssignmentGroupingView>, resizeAction: boolean, byDelta: boolean,
        mainAssignmentLockId: number, oldRess: string, newRess: string): Promise<boolean> {

        const dp = {
            resizeAction: resizeAction,
            projNr: projNr,
            pIndex: pIndex,
            groupings: groupings,
            mainAssignmentLockId: mainAssignmentLockId,
            settings: this.props.settings,
            onGetDataBack: (data: any) => {
                this.setState({ movedGroupingArray: data })
            },
            oldRess: oldRess,
            newRess: newRess,
            newStart: newStart,
            newEnd: newEnd,
            byDelta: byDelta,
            assignmentsNoGrouping: assignmentsNoGrouping

        } as ResourcePlanningGroupingDialogProps;

        const myModal = ModalHelper.createModal<ResourcePlanningGroupingDialogProps>(ResourcePlanningGroupingDialog);
        return myModal(dp);
    }

    //toDo Clientseitig evtl in einen eigenen Service auslagern
    private moveEvent = async (id: string, newStart: Date, newEnd: Date, newResourceId: string, oldResourceId: string, resizeAction: boolean, byDelta: boolean, slot: ResourceSlot = null) => {
        let arr = id.split("|");
        let that = this;
        //let newStartGroup;

        const acceptMoveEx = async (data: any[], showMessage: boolean): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {
                const result = await HTTPService.post<JsonResultClass>(
                    "ResourcePlanningScheduler/MoveAssignmentEx",
                    { settings: this.props.settings, moveAssigmentInfoEx: data })

                if (result.Code == 0) {

                    await that.doRefresh(null, null, false);

                    if (showMessage)
                        NotificationHelper.showSuccessMessage(result.Message);

                    resolve(true);
                }
                else {
                    await that.doRefresh(null, null, false);

                    NotificationHelper.showErrorMessage(this.translations["WebSMS.ResourcePlaningGrouping.GruppeNichtVerschoben"] + ' ' + result.Message);

                    resolve(false);
                }
            });
        }

        const acceptMove = async (event: ResourcePlanningSchedulerEventViewModel, showMessage: boolean): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {
                const result = await HTTPService.post<JsonResultClass<MovedAssignmentInfo>>(
                    "ResourcePlanningScheduler/MoveAssignment",
                    {
                        projNr: arr[0], pIndex: arr[1], settings: that.props.settings, newStart: Helper.dates.getISODateString(newStart), newEnd: Helper.dates.getISODateString(newEnd),
                        newResourceId: newResourceId, oldResourceId: oldResourceId, resizeAction: resizeAction, slot: slot, byDelta: byDelta
                    })

                if (result.Code === 0) {
                    let change = true;

                    that.absenceTimeAssignment = { StartIst: result.Data.start, EndeIst: result.Data.end };

                    if (that.props.settings.AutoUpdateScheduler ||
                        this.getSlotModeSourceId() != null ||
                        result.Data.otherAssignmentsChanged) {
                        //newStartGroup = result.Data.start;
                        await that.doRefresh(result.Data.projNr, result.Data.pIndex);
                    }
                    else {
                        //newStartGroup = result.Data.start;
                        event.Start = result.Data.start;
                        event.End = result.Data.end;
                        event.WorkStart = result.Data.arbeitsbeginnist;
                        event.WorkEnd = result.Data.arbeitsendeist;
                        event.ResourceId = result.Data.resourceId;
                        event.ResourceName = result.Data.resourceName;
                        //event.Utilization = result.Data.utilization;
                        event.EpochStart = result.Data.epochStart;
                        event.EpochEnd = result.Data.epochEnd;
                        event.EpochWorkStart = result.Data.epochWorkStart;
                        event.EpochWorkEnd = result.Data.epochWorkEnd;
                        event.ContinuationJourney = result.Data.continuationJourney === 1;
                        event.AssignmentUtilizationInfo = result.Data.AssignmentUtilizationInfo;
                        event.RecordRight = result.Data.recordRight;
                        event.IconInfo = result.Data.IconInfo;
                        event.StatusMarkingColor = result.Data.StatusMarkingCode;
                        event.StatusMarkingCode = result.Data.StatusMarkingCode;
                        event.SendStatus = result.Data.StatusSend;
                        if (result.Data.travelDataReset) {
                            event.WayThere = null;
                            event.WayBack = null;
                            // andere Events mit PrevAssignmentId auf unseres aktualisieren.
                            that.schedulerRef.resetLinksForPrevAssignment(event.IsGuid);
                        }
                        // Message beim Verschieben nur ausgeben wenn es tatsächlich eine Änderung (Start,End,Resource) gibt
                        let dpsEvent = that.schedulerRef.getDps().events.find(event.Id);
                        let dpsOldStart = dpsEvent.start();
                        let dpsOldEnd = dpsEvent.end();
                        let dpsOldResource = dpsEvent.resource();
                        that.schedulerRef.partialRefresh("change", event);
                        if (dpsOldStart == dpsEvent.start() && dpsOldEnd == dpsEvent.end() && dpsOldResource == dpsEvent.resource()) {
                            change = false;
                        }
                    }

                    if (showMessage && change) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    }

                    resolve(true);
                }
                else {

                    NotificationHelper.showErrorMessage(result.Message);
                    resolve(false);
                }
            }
            )
        }

        const removeLock = async (ids: any[]): Promise<boolean> => {
            return new Promise<boolean>(async (resolve) => {
                const result = await HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/ReleaseLockedAssignments", { lockIds: ids });
                resolve(result.Code === 0);
            });
        }

        const runMoveCommand = async function () {
            {
                let event = that._getData().Events.find(f => f.Id == id);

                let projectCanNotBeEdited = false;
                if (Helper.hasValue(event.ProjectStatus) && Helper.hasValue(event.ProjectStatus.Planung)) {
                    projectCanNotBeEdited = (event.ProjectStatus.Planung === 2) ||
                        (that.props.settings.AssignmentEditingTiedToProjectStatus && event.ProjectStatus.Planung === 0);
                }

                if (Helper.hasValue(event.ProjectStatus) && Helper.hasValue(event.ProjectStatus.Planung)) {
                    if (event.ProjectStatus.Planung === 2) {
                        NotificationHelper.showInfoMessage(
                            that.translations["Einsatz.ProjectEditingLocked"].replace("{ProjNr}", arr[0]))
                    } else if (that.props.settings.AssignmentEditingTiedToProjectStatus &&
                        event.ProjectStatus.Planung === 0) {
                        NotificationHelper.showInfoMessage(
                            that.translations["WebSMS.ResourcePlanning.NoEditingCauseStatus"]);
                    }
                }

                let checkSkills = true;
                let recalculateAndCheckSkills = !projectCanNotBeEdited && that.settings.SkillsEnabled && (event.KennungTyp === Kennungstyp.Adressbezogen || event.KennungTyp === Kennungstyp.Projektbezogen || event.KennungTyp == Kennungstyp.Wartung);
                if (recalculateAndCheckSkills) {
                    checkSkills = await ResourcePlanningHelper.reCalcualteSkills(arr[0], parseInt(arr[1]), newStart, newEnd, resizeAction, byDelta, that.props.settings);
                }

                let additionalEventMovingInfo: AdditionalEventMovingInfo = { targetRessNr: newResourceId, projNr: arr[0], pIndex: Number(arr[1]), checkSkills: recalculateAndCheckSkills };
                let isOk = await OpenEventMovingDialog(event, additionalEventMovingInfo, Helper.getTranslation("WebSMS.ResourcePlanningScheduler.ReallyMove"));
                if (!isOk)
                    return;

                let start = kendo.parseDate(event.Start);
                let workStart = kendo.parseDate(event.WorkStart);
                let newWorkStart = ResourcePlanningHelper.getNewWorkStartForSlaCheck(start,
                    workStart,
                    newStart,
                    that.props.settings.TimeResolutionType === 0);

                const checkSla = that.settings.SlaViewActive
                    ? true
                    : await ResourcePlanningHelper.checkSla(newWorkStart,
                        arr[0],
                        Number(arr[1]),
                        null,
                        null,
                        that.props.settings.ShowAssignmentsWithTimeZones);

                if (checkSkills && checkSla && !projectCanNotBeEdited) {
                    const assNoItems: Array<AssignmentGroupingView> = [];
                    const groupings: Array<number> = [];

                    if (that.state.multiSelectActive && that.state.multiSelectEvents.length > 0) {
                        that.state.multiSelectEvents.forEach(e => {
                            if (that.props.settings.AssignmentGroupingActive && e.Gruppierung > 0)
                                groupings.push(e.Gruppierung);
                            else
                                assNoItems.push({ projNr: e.Projnr, pIndex: e.Pindex });

                        });
                    } else {
                        if (that.props.settings.AssignmentGroupingActive && event.Gruppierung > 0)
                            groupings.push(event.Gruppierung);
                    }

                    //1. eine MoveAssignment mit Rollback...
                    let resultMoveAssignmentCheck = null;
                    if (assNoItems.length > 0 || groupings.length > 0) {
                        resultMoveAssignmentCheck = await HTTPService.post<JsonResultClass>(
                            "ResourcePlanningScheduler/MoveAssignmentCheck",
                            {
                                projNr: arr[0], pIndex: arr[1], settings: that.props.settings, newStart: Helper.dates.getISODateString(newStart), newEnd: Helper.dates.getISODateString(newEnd),
                                newResourceId: newResourceId, oldResourceId: oldResourceId, resizeAction: resizeAction, slot: slot, doLock: true, byDelta: byDelta
                            });
                    }
                    if (resultMoveAssignmentCheck == null || resultMoveAssignmentCheck.Code === 0) {
                        const lockId = resultMoveAssignmentCheck != null ? resultMoveAssignmentCheck.Data.lockId : null;

                        if (resultMoveAssignmentCheck != null &&
                            (assNoItems.length > 0 || groupings.length > 0)
                        ) {
                            //2 Grouppingmove .. Digalog mit OK, Cancel     

                            if (await that.asyncGroupDialog(arr[0], parseInt(arr[1]), newStart, newEnd, groupings,
                                assNoItems, resizeAction, byDelta, lockId, oldResourceId, newResourceId)) {
                                //4. Move in gantt
                                const hasData = (that.state.movedGroupingArray != null && that.state.movedGroupingArray.length > 0);

                                //3 Haupteinsatz verschieben
                                if (await acceptMove(event, !hasData)) {
                                    //4.2 Gruppe 
                                    if (hasData)
                                        await acceptMoveEx(that.state.movedGroupingArray, true);
                                }
                            }
                        } else {
                            //2 Gruppiingmove, aber StartIst wurde nicht geändert ... mehrfachbelegung 
                            let removeLocks = resultMoveAssignmentCheck != null ? await removeLock([lockId]) : true;
                            if (removeLocks && await acceptMove(event, true)) {
                                if (that.props.settings.TimeResolutionType !== that.timeResolutionTypes.Hours) {
                                    const overlapResult = await HTTPService.post<JsonResultClass<OverlapPresenceTimeLists>>(
                                        "ResourcePlanningScheduler/CheckOverlapPresenceTime",
                                        {
                                            projnr: arr[0],
                                            pindex: arr[1],
                                            ressnr: newResourceId,
                                            // startIst: Helper.dates.getISODateString(newStart),
                                            startIst: that.absenceTimeAssignment.StartIst,
                                            // endeIst: Helper.dates.getISODateString(newEnd),
                                            endeIst: that.absenceTimeAssignment.EndeIst,
                                            resizeAction: resizeAction,
                                            byDelta: byDelta,
                                            settings: that.props.settings
                                        }
                                    );
                                    if (overlapResult.Code == 0 && Helper.hasValue(overlapResult.Data)) {
                                        if (Config.user.splitUpAndCutAssignment && overlapResult.Code === 0 && overlapResult.Data.assignmetsToSplit != null && overlapResult.Data.assignmetsToSplit.length > 0) {
                                            if (overlapResult.Data.assignmentsWithFixStartOrEnd != null && overlapResult.Data.assignmentsWithFixStartOrEnd.length > 0)
                                                NotificationHelper.showWarningMessage(Helper.getTranslation("Einsatz.FixierterEinsatzCanNotSplit"));
                                            that.listRemoveItems = overlapResult.Data.assignmetsToSplit;
                                            that.listTotalItems = overlapResult.Data.assignmetsToSplit;
                                            that.listNotRemoveItems = [];
                                            // that.absenceTimeAssignment = { StartIst: event.Start, EndeIst: event.End };
                                            if (Config.user.splitUpAndCutAssignment) {
                                                that.openDialog();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else// if (resultMoveAssignmentCheck.Code === 0) { 
                    {
                        NotificationHelper.showErrorMessage(resultMoveAssignmentCheck.Message);
                    }
                }
            }
        }

        const event = this._getData().Events.find(e => e.Id === id);
        if (!this.props.settings.GroupByResources) {
           // newResourceId = event.ResourceId;
        }
        
        let move = false;
        const isOk = await Util.CheckForMultipleOccupancies(event.Projnr, event.Pindex, newStart, newEnd, newResourceId);
        if (isOk)
            move = await Util.CheckApproval(arr[0], arr[1], newStart, newEnd, newResourceId)
        if (move) {
            await runMoveCommand();
            if (this.props.settings.GroupByMachines) {
                this.updateMachineView(id);
            }
        }
    }

    private updateMachineView = (id: string) => {
        const event = this._getData().Events.find(ev => ev.Id === id);
        const newStart = Helper.dates.getISODateString(event.Start);
        const newEnd = Helper.dates.getISODateString(event.End);
        this._getData().Events.filter(ev => ev.Id.includes(id)).forEach((event, index) => {
            if (index > 0) {
                event.Start = newStart;
                event.End = newEnd;
                this.schedulerRef.partialRefresh("change", event, false);
            }
        });
        this.schedulerRef.partialRefresh("change", event); //trigger updates 
    }

    private fitToWorkingTime = (id: string, resourceId: string) => {
        let index = Helper.findIndex(this._getData().Events, "Id", id);
        let event = this._getData().Events[index];
        let arr = id.split("|");
        HTTPService.post<JsonResultClass<WorkingTimeFittedInfo>>("ResourcePlanningScheduler/FitAssignmentToWorkingTime", { projNr: arr[0], pIndex: arr[1] })
            .then(result => {
                if (result.Code === 0) {
                    if (this.props.settings.AutoUpdateScheduler) {
                        this.doRefresh(result.Data.projNr, result.Data.pIndex).then();
                    }
                    else {
                        event.End = result.Data.endeIst;
                        event.WorkEnd = result.Data.arbeitsendeist;
                        event.Arbeitszeit = result.Data.arbeitszeit;
                        event.SendStatus = result.Data.SendState;
                        event.StatusMarkingCode = result.Data.StatusMarkingCode;
                        event.StatusMarkingColor = result.Data.StatusMarkingColor;
                        this.schedulerRef.partialRefresh("change", event);
                        this.refreshGeomap([resourceId]).then();
                    }
                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }


    private openEvent = (id: string, resourceId: string) => {
        let arr = id.split("|");
        this.openSheetEventResource(this.translations["Einsatz.Balkeninfo"], "ResourcePlanning/Edit", { projNr: arr[0], pIndex: arr[1], mandant: arr.length > 2 ? arr[2] : null, resourceId: resourceId, isWindow: true });
    }

    private newFromResource = (resourceId: string) => {
        this.openSheetEventResource(this.translations["Einsatz.Balkeninfo"], "ResourcePlanning/Edit", { resourceId: resourceId, isWindow: true });
    }

    private newPmFromResource = (resourceId: string) => {
        this.openSheetEventResource(this.translations["Einsatz.NeuenEinsatzAnlegenPM"], "ResourcePlanningPM/Index", { resourceId: resourceId });
    }

    private openResource = (resourceId: string) => {
        this.openSheetEventResource(this.translations["Ressource.Ressource"], "Resource/Edit", { id: resourceId, isWindow: true }, false, null, true);
    }

    private newFromSelection = (entityId: string, start: Date, end: Date) => {
        let data: {
            resourceId?: string,
            adrNr?: string,
            projNr?: string,
            from: string,
            to: string,
            isWindow: boolean
        } = {
            from: Helper.dates.getISODateString(start),
            to: Helper.dates.getISODateString(end),
            isWindow: true
        };
        if (this.props.settings.GroupByResources) {
            data.resourceId = entityId;
        } else if (this.props.settings.GroupByAddresses) {
            data.adrNr = entityId;
        } else if (this.props.settings.GroupByProjects) {
            data.projNr = entityId;
        }
        this.openSheetEventResource(this.translations["Einsatz.Balkeninfo"], "ResourcePlanning/Edit", data);
    }

    private newPmFromSelection = (resourceId: string, start: Date, end: Date) => {
        this.openSheetEventResource(this.translations["Einsatz.Balkeninfo"], "ResourcePlanningPM/Index", { resourceId: resourceId, from: Helper.dates.getISODateString(start), to: Helper.dates.getISODateString(end) });
    }

    private openSlot = (slot: ResourceSlot, resource: string, adrNr: string) => {
        const minutes = this.suitableResourcesSearchSettings.continuousPeriod * (this.suitableResourcesSearchSettings.continuousPeriodUnit === ContinuousPeriodUnit.Days ? 1440 : 60);
        const slotAssignmentEndDate = new Date(Helper.dates.toDate(slot.startDate).getTime() + minutes * 60000);
        let endDate: string = Helper.dates.getISODateString(slotAssignmentEndDate);
        this.openSheetEventResource(
            this.translations["Einsatz.Balkeninfo"],
            "ResourcePlanning/Edit",
            {
                resourceId: resource,
                from: Helper.dates.getISODateString(slot.startDate),
                to: endDate,
                adrNr: adrNr,
                isWindow: true
            }
        );
    }

    private newAssigmentGrouping = (events: Array<ResourcePlanningSchedulerEventViewModel>, updateSettings: boolean = false) => {
        HTTPService.get<JsonResultClass>("ResourcePlanning/GetNewGroupingId")
            .then(result => {
                if (result.Code === 0) {

                    const projectKeys: Array<{ ProjNr: string, PIndex: number }> = [];
                    events.forEach((event) => {
                        projectKeys.push({ ProjNr: event.Projnr, PIndex: event.Pindex });
                    });

                    const gruppe = result.Data;

                    Helper.saveDataToStorage("AssignentGroupingLastNew", gruppe, false, BrowserStorageType.Session);

                    ResourcePlaningGroupingHelper.updateAssigmentGroupList(projectKeys, gruppe, false, () => {
                        let ev = null;
                        events.forEach((event) => {
                            event.Gruppierung = gruppe;
                            this.schedulerRef.partialRefresh("change", event, false);
                            ev = event;
                        });

                        if (ev != null)
                            this.schedulerRef.partialRefresh("change", ev);
                    });

                    if (updateSettings)
                        this.settingsRef.rebuildMultiSelectMenu();

                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private changeToLastAssigmentGrouping = (events: Array<ResourcePlanningSchedulerEventViewModel>, last: number) => {

        const projectKeys: Array<{ ProjNr: string, PIndex: number }> = [];
        events.forEach((event) => {
            projectKeys.push({ ProjNr: event.Projnr, PIndex: event.Pindex });
        });

        ResourcePlaningGroupingHelper.updateAssigmentGroupList(projectKeys, last, false, () => {
            let ev = null;
            events.forEach((event) => {
                event.Gruppierung = last;
                this.schedulerRef.partialRefresh("change", event, false);
                ev = event;
            });
            if (ev != null)
                this.schedulerRef.partialRefresh("change", ev);
        });
    }

    private deleteAssigmentGrouping = (events: Array<ResourcePlanningSchedulerEventViewModel>) => {
        const projectKeys: Array<{ ProjNr: string, PIndex: number }> = [];
        events.forEach((event) => {
            projectKeys.push({ ProjNr: event.Projnr, PIndex: event.Pindex });
        });

        ResourcePlaningGroupingHelper.updateAssigmentGroupList(projectKeys, 0, false, () => {
            let ev = null;
            events.forEach((event) => {
                event.Gruppierung = 0;
                ev = event;
                this.schedulerRef.partialRefresh("change", event, false);
            });
            if (ev != null)
                this.schedulerRef.partialRefresh("change", ev);
        })
    }

    private listAssigmentGrouping = (grouping: number) => {
        const url = "ResourcePlanning/ResourcePlanningGroupingList?grouping=" + grouping;
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, null, true);
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.doRefresh().then();
        });
        General.Functions.HistoryState.pushSheetState(sheet, url);
    }


    private changeAssigmentGrouping = (events: Array<ResourcePlanningSchedulerEventViewModel>) => {
        const url = "DynamicSearch/Window/AssignmentGrouping?fullObject=true";

        const componentHelper = ComponentHelper.createFactory();
        const componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        componentSearchProps.field.searchWindowUrl = url;

        new SearchHelper().openSearch(componentSearchProps, null,
            (field: string, object: any) => {
                const projectKeys: Array<{ ProjNr: string, PIndex: number }> = [];
                events.forEach((event) => {
                    projectKeys.push({ ProjNr: event.Projnr, PIndex: event.Pindex });
                });

                ResourcePlaningGroupingHelper.updateAssigmentGroupList(projectKeys, object.gruppierung, null,
                    () => {
                        const gruppe = object.gruppierung;
                        let ev = null;
                        events.forEach((event) => {
                            event.Gruppierung = gruppe;
                            this.schedulerRef.partialRefresh("change", event, false);
                            ev = event;
                        });
                        if (ev != null)
                            this.schedulerRef.partialRefresh("change", ev);
                    }
                );

                if (field) {
                    //implicitly warning
                }
            }, null);
    }

    private calculateRoute = (eventId: string) => {
        if (eventId) {
            this.setAssignmentRouteAsStandardRoute(eventId);
        }
    }

    private calculateTravelTimes = (eventId: string) => {
        if (eventId) {
            this.postTravelTimesRequest(eventId);
        }
    }

    private openSheetEventResource = (title: string, url: string, data: any, refresh: boolean = true, externalData: any = null, resourceSheet: boolean = false) => {
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, data, externalData, true);
        sheet.setTitle(title);
        let entitySaved = false;

        sheet.bind(SheetEventType.Close, () => {
            if (entitySaved)
                //update if entity was saved
                this.doRefresh(data.projNr, data.pIndex).then();
            else {
                //allways update (maschienes can be changed without enitity.save)
                if (this.props.settings.GroupByMachines) {
                    const id = `${data.projNr}|${data.pIndex}`;
                    this.updateMachineView(id);
                }
            }
        });

        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            entitySaved = true;
            if (resourceSheet) {
                this.doRefresh(data.projNr, data.pIndex).then();
            }
        });

        const query = Helper.addQueryStringParameters(url, data);
        General.Functions.HistoryState.pushSheetState(sheet, query);

        if (refresh) {
            sheet.bind(SheetEventType.Custom, (cus) => {
                switch (cus.command) {
                    case "partialRefresh":
                        if (this.props.settings.AutoUpdateScheduler || cus.doFullRefresh) {
                            this.doRefresh(data.projNr, data.pIndex).then();
                        }
                        else {
                            HTTPService.post<JsonResultClass>("ResourcePlanningScheduler/GetEvent", { settings: this.props.settings, projNr: cus.projnr, pIndex: cus.pindex })
                                .then(result => {
                                    let index = Helper.findIndex(this._getData().Events, "Id", cus.projnr + "|" + cus.pindex);
                                    let event: ResourcePlanningSchedulerEventViewModel = result.Data;
                                    if (result.Code === 1) {
                                        NotificationHelper.showErrorMessage(result.Message);
                                    }
                                    else if (event !== null) {
                                        if (index === -1) {
                                            this.schedulerRef.partialRefresh("add", event);
                                        } else {
                                            this.schedulerRef.partialRefresh("change", event);
                                        }
                                    }
                                    else if (index !== -1) {
                                        this.schedulerRef.partialRefresh("remove", this._getData().Events[index]);
                                    }
                                });
                        }
                        break;
                    case "afterRebook":
                        sheet.hide(() => {
                            let event: ResourcePlanningSchedulerEventViewModel = cus.oldData;
                            event.Id = cus.oldId;
                            this.schedulerRef.partialRefresh("remove", event);
                            setTimeout(() => {
                                this.openEvent(cus.id, null)
                            }, 10)
                        });
                        break;
                    case "reloadFlags":
                        this.reloadFlags().then();
                        break;
                }

            });
        }
    }
    // End actions

    // Start geomap
    private prepareGeomapConnection = (callback?: () => void) => {
        if (this.geomapRpcService.isDisconnected()) {
            this.geomapRpcService.start(callback);
        }
        else {
            if (typeof callback === "function") {
                callback();
            }
        }
    }

    private getGeomapParameters = async () => {
        let resourceIDs = this.getResourceIDs();
        if (resourceIDs.length > 40 || this.schedulerRef.getDps().events.all().length > 300) {
            DialogHelper.alert(this.translations["GeoMap.MaximumAmountOfResourcesExceeded"]);
            return;
        }
        if (resourceIDs.length > 20 || this.schedulerRef.getDps().events.all().length > 150) {
            if (!(await DialogHelper.confirm(this.translations["GeoMap.TooManyResourcesSelected"]))) {
                return;
            }
        }
        let groups = this.getGroupsForGeomap();
        let parameterString = this.getParameterString(resourceIDs, groups);
        let dps = this.schedulerRef.getDps();
        let start = (dps.startDate as DayPilot.Date).toDateLocal();
        let end = (dps.startDate as DayPilot.Date).addDays(dps.days).toDateLocal();
        let dateParameters = this.getDateParameters(start, end);

        return {
            geomapType: "&type=resourceRoutes",
            parameterString: parameterString,
            dateParameters: dateParameters,
            geomapResourceViewParamObject: { resourceIDs: resourceIDs, start: start, end: end, groups: groups }
        } as GeomapParameterContainer;
    }

    private getResourceIDs = () => {
        return this.schedulerRef.getDps().rows.all()
            .filter(function (e) {
                return e.id.slice(0, 1) === "r";
            })
            .map(function (e) {
                return e.id.slice(e.id.indexOf("|") + 1);
            });
    }

    private getGroupsForGeomap = () => {
        return this.schedulerRef.getDps().rows.all()
            .filter(function (e) {
                return e.id.slice(0, 1) === "g";
            })
            .map(function (e) {
                return e.id.slice(e.id.indexOf("|") + 1);
            });
    }

    private getParameterString = (resourceIDs: string[], groups: string[]) => {
        let pStr = "&";
        for (let i = 0; i < resourceIDs.length; i++) {
            pStr += "res" + i + "=" + resourceIDs[i];
            if (i !== resourceIDs.length - 1)
                pStr += "&";
        }
        if (groups.length > 0) {
            pStr += "&";
        }
        for (let i = 0; i < groups.length; i++) {
            pStr += "group" + i + "=" + groups[i];
            if (i !== groups.length - 1)
                pStr += "&";
        }

        return pStr;
    }

    private getDateParameters = (start: Date, end: Date) => {
        return "&start=" + encodeURIComponent(Helper.dates.getISODateString(start)) + "&end=" + encodeURIComponent(Helper.dates.getISODateString(end));
    }

    private openInPlanningBoard = (geomapType?: string, dateParameters?: string, parameterString?: string) => {
        this.prepareGeomapConnection(() => { this.afterPrepare(geomapType, dateParameters, parameterString) });
    }

    private afterPrepare = (geomapType: string, dateParameters: string, parameterString: string) => {
        const routeColorValue = this.geomapViewMode === GeomapViewMode.ResourceView ? this.state.geomapRouteColors : null;
        if (this.geomapConfig === null) {
            HTTPService.get(`Directions/GetGeomapConfiguration?frompb=true${geomapType || ""}${dateParameters || ""}${parameterString || ""}`)
                .then(result => {
                    this.geomapConfig = result;
                    this.setState({ geomapRouteColors: routeColorValue });
                });
        }
        else {
            this.setState({ geomapRouteColors: routeColorValue });
        }
    }

    private setStandardRoute = (resourceId: string) => {
        if (!this.geomapRpcService.isDisconnected() && resourceId.slice(0, 1) === "r") {
            let ressNr = resourceId.slice(resourceId.indexOf("|") + 1);
            let dps = this.schedulerRef.getDps();
            let start = (dps.startDate as DayPilot.Date).toDateLocal();
            let end = (dps.startDate as DayPilot.Date).addDays(dps.days).toDateLocal();

            this.geomapRpcService.setStandardRoute(ressNr, Helper.dates.getISODateString(start) as any, Helper.dates.getISODateString(end) as any, Config.user.userName, Config.user.languageId);
        }
    }

    private setAssignmentAsStandardRoute = (eventId: string) => {
        if (!this.geomapRpcService.isDisconnected()) {
            let splitted = eventId.split("|");
            let projNr = splitted[0];
            let pIndex = parseInt(splitted[1]);

            this.geomapRpcService.setAssignmentAsStandardRoute(projNr, pIndex, Config.user.userName, Config.user.languageId);
        }
    }

    private setSlotStandardRoute = (slot: ResourceSlot) => {
        if (!this.geomapRpcService.isDisconnected()) {
            this.geomapRpcService.setSlotStandardRoute(
                slot.traveldataInfo.fromHome,
                slot.traveldataInfo.backHome,
                slot.traveldataInfo.fromHome ? null : slot.prevAssignmentId,
                slot.sourceAssignmentId,
                slot.traveldataInfo.backHome ? null : slot.nextAssignmentId,
                slot.ressNr,
                Config.user.userName,
                Config.user.languageId);
        }
    }

    private setAssignmentRouteAsStandardRoute = (eventId: string) => {
        this.openGeomapAndCallFunction(this.callSetAssignmentRoute, [eventId]);
    }

    private callSetAssignmentRoute = (eventId: string) => {
        let splitted = eventId.split("|");
        let projNr = splitted[0];
        let pIndex = parseInt(splitted[1]);

        this.geomapRpcService.setAssignmentRouteAsStandardRoute(projNr, pIndex, Config.user.userName, Config.user.languageId);
    }

    private refreshStandardRoute = (resourceIdsChanged?: Array<string>) => {
        if (this.geomapRpcService.isDisconnected())
            return;

        let selectedRows = this.schedulerRef.getDps().rows.selection.get();
        if (selectedRows.length > 0) {
            // Check if update is needed
            if (resourceIdsChanged && resourceIdsChanged.length > 0 && resourceIdsChanged.indexOf(selectedRows[0].id) === -1) {
                return;
            }

            this.setStandardRoute(selectedRows[0].id);
        }
    }

    private refreshGeomap = async (resourceIdsChanged?: Array<string>) => {
        if (this.geomapViewMode === GeomapViewMode.ResourceView) {
            let parameters = await this.getGeomapParameters();
            if (parameters) {
                const paramObject = parameters.geomapResourceViewParamObject;
                this.geomapRpcService.updateResourceRoutes(paramObject.resourceIDs, paramObject.start, paramObject.end, paramObject.groups);
            }
        }
        this.refreshStandardRoute(resourceIdsChanged);
    }

    private postTravelTimesRequest = (eventId: string) => {
        let splitted = eventId.split("|");
        let projNr = splitted[0];
        let pIndex = parseInt(splitted[1]);

        HTTPService.post<JsonResultClass>("Directions/CalculateTravelTimes", { projNr: projNr, pIndex: pIndex, forceCheckLock: true })
            .then(result => {
                if (result.Code === 0) {
                    if (this.props.settings.AutoUpdateScheduler) {
                        this.doRefresh(projNr, pIndex).then();
                    }
                    else {
                        const assignments = result.Data as AssignmentTraveldataModel[];
                        if (assignments != null && assignments.length > 0) {
                            assignments.forEach(a => {
                                const event = this.getEvent(a.projNr + "|" + a.pIndex);
                                if (event != null) {
                                    event.Start = a.assignmentTimes?.startIst;
                                    event.EpochStart = Helper.dates.toDate(event.Start).getTime();
                                    event.End = a.assignmentTimes?.endeIst;
                                    event.EpochEnd = Helper.dates.toDate(event.End).getTime();
                                    event.WayBack = a.wayBack;
                                    event.WayThere = a.wayThere;
                                    this.schedulerRef.partialRefresh("change", event, false);
                                }
                            });
                            //trigger update 
                            const ev = this.getEvent(projNr + "|" + pIndex);
                            this.schedulerRef.partialRefresh("change", ev);
                        }
                    }

                    NotificationHelper.showSuccessMessage(result.Message);
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }
    private openGeomapAndCallFunction = (callback: (...args: any[]) => void, args: any[]) => {
        if (!this.geomapRpcService.isDisconnected()) {
            this.geomapRpcService.getRouteOrTabCount().then((result: number) => {
                if (result > 1) {
                    callback(...args);
                    if (result === 2 && this.geomapConfig != null && this.geomapViewMode === GeomapViewMode.None) {
                        this.toggleGeomap();
                    }
                }
                else {
                    this.geomapViewMode = GeomapViewMode.StandardView;
                    this.openInPlanningBoard();
                    if (this.geomapConfig != null) {
                        callback(...args);
                    }
                    else {
                        window.addEventListener("GeomapLoaded", () => { callback(...args); }, { once: true } as AddEventListenerOptions);
                    }
                }
            });
        }
        else {
            this.geomapViewMode = GeomapViewMode.StandardView;
            this.openInPlanningBoard();
            window.addEventListener("GeomapLoaded", () => { callback(...args); }, { once: true } as AddEventListenerOptions);
        }
    }

    private setOrRemoveRouteMarking = (resourceId: string, selected: boolean) => {
        if (!this.geomapRpcService.isDisconnected() && resourceId.slice(0, 1) === "r") {
            const ressNr = resourceId.slice(resourceId.indexOf("|") + 1);
            if (selected) {
                this.geomapRpcService.markRouteByRessNr(ressNr);
            }
            else {
                this.geomapRpcService.removeRouteMarking();
            }
        }
    }

    private setResourceViewInPb = async () => {
        let parameters = await this.getGeomapParameters();
        if (parameters) {
            this.geomapViewMode = GeomapViewMode.ResourceView;
            if (this.geomapConfig != null) {
                this.geomapConfig = null;
                this.setState({}, () => {
                    this.openInPlanningBoard(parameters.geomapType, parameters.dateParameters, parameters.parameterString);
                })
            }
            else {
                this.openInPlanningBoard(parameters.geomapType, parameters.dateParameters, parameters.parameterString);
            }
        }
    }

    receiveRouteColors = (colors: Array<RouteColors>) => {
        this.setState({ geomapRouteColors: colors }, this.schedulerRef.getDps().update);
    }

    private renderGeomap = () => {
        if (this.geomapConfig && this.geomapViewMode !== GeomapViewMode.None) {
            const config = this.geomapConfig;
            const tabId = `PB_integrated_${config.Type ? config.Type + "_" : ""}${kendo.guid()}`;
            return (
                <div className="flex-container__item" style={{ borderLeft: "3px solid #bbb" }}>
                    <DirectionsApp context={{ contextType: "directions" }} title={"Directions"}
                        type={config.Type} id1={config.Id1} id2={config.Id2} resourceIDs={config.ResourceIds} groups={config.Groups} start={kendo.parseDate(config.Start)} end={kendo.parseDate(config.End)}
                        sortAfterOptimisation={config.SortAfterOptimisation} resourceFilterDaysBefore={config.ResourceFilterDaysBefore}
                        resourceFilterDaysAfter={config.ResourceFilterDaysAfter} perimeterDaysBefore={config.PerimeterDaysBefore} perimeterDaysAfter={config.PerimeterDaysAfter}
                        sliderMax={config.SliderMax} sliderSmallStep={config.SliderSmallStep} sliderLargeStep={config.SliderLargeStep} tabId={tabId}
                        useMiles={config.UseMiles} minimumClusterSize={config.MinimumClusterSize} clusterGridSize={config.ClusterGridSize} maxContainerSize={config.MaxContainerSize} searchAlongRouteAvailable={config.SearchAlongRouteAvailable} schedulerView={true} />
                </div>
            );
        }
        return null;
    }
    // End geomap

    // noinspection JSUnusedGlobalSymbols
    public showSlotDebugInfo = () => {
        return this.state.interactiveSlotModeActive && this.state.slotModeActive && this.slotSearchSettings.slotEnableDebugMode
    }

    private _forceUpdate = false;
    private renderRightDrawerComponent = () => {
        if (this.rightDrawerContainer !== null) {
            let entity: Entity = {
                IsNew: true,
                RecordRight: {
                    CanRead: true, CanWrite: true
                },
                IsWatchable: false,
                IsWatched: false
            };

            let markedEvent = this.schedulerRef !== null ? this.schedulerRef.getMarkedEvent() : null;

            if (markedEvent == null && this.state.interactiveSlotModeActive && this.state.slotModeActive) {
                const id = this.getSlotModeSourceId();
                if (Helper.hasValue(id)) {
                    markedEvent = this._getData().Events.find(f => f.Id == id && f.ResourceId.startsWith("g") && f.RecordRight.CanWrite /* && f.TargetHours !== null */);
                }
            }

            if (markedEvent != null) {
                if (markedEvent.IsAnnonymous)
                    return;
                
                entity = $.extend({}, entity, markedEvent);
                entity.IsNew = false;
            }

            let slotDebugInfo = this.rightDrawerContainer.multipleComponents
                .find((x: { moduleName: string; }) => x.moduleName == 'app/core/components/slotDebugInfo');
            if (slotDebugInfo != null) {
                let data = null;

                if (this.state.interactiveSlotModeActive && this.state.slotModeActive && this.slotSearchSettings.slotEnableDebugMode) {
                    data = this.state.slotNotApplicableData
                }

                slotDebugInfo.props = {
                    data: data
                };
            }

            if (this._forceUpdate) {
                this.common.commandManager.runCommand("updateStaticGuid", Commands.REFRESH);
                this._forceUpdate = false;
            }
            
            this.common.updateEntity(entity);

            return <RightDrawerContainer
                moduleName={this.rightDrawerContainer.moduleName}
                appName={this.rightDrawerContainer.appName}
                visible={this.rightDrawerContainer.visible}
                width={this.rightDrawerContainer.width}
                customProps={this.rightDrawerContainer.props}
                commandManager={this.common.commandManager}
                entity={entity}
                handleEval={this.common.evalAction}
                renderAlways={this.rightDrawerContainer.renderAlways}
                multipleComponents={this.rightDrawerContainer.multipleComponents}
            />
        }

        return null;
    }

    private setConsiderHiddenAssignmentsForCapacity = () => {
        this.schedulerRef.setConsiderHiddenAssignmentsForCapacity(this.settings.ProjNrs.length > 0 && this.settings.CapacityIgnoreProjectFilter);
    }

    private _selectEventOnOpen = () => {
        $(window).off("selectEventOnOpen");
        const ev = this.schedulerRef.getMarkedEvent();
        if (ev)
            this.calculateRoute(ev.Id);
    }

    private toggleGeomap = () => {
        if (this.geomapViewMode === GeomapViewMode.None) {
            this.props.settings.DisplayGeomapMap = true;
            this.geomapViewMode = GeomapViewMode.StandardView;
            this.openInPlanningBoard();
            $(window).on("selectEventOnOpen", this._selectEventOnOpen);
        }
        else {
            this.geomapViewMode = GeomapViewMode.None;
            this.props.settings.DisplayGeomapMap = false;
            $(window).off("selectEventOnOpen");
            this.setState({});
        }
        this.saveDisplaySettings();
    }

    private renderWorklist = () => {
        let slotPlaningReadonly = !this.settings.GroupByResources || !Config.user.hasDispatchLicense;
        if (this.settings.DisplayWorkListInTable) {
            return (
                <WorkList
                    ref={(r) => this.workListRef = r}
                    translations={this.translations}
                    gridOptions={this.workListGridOptions}
                    gridSlotOptions={this.workListSlotGridOptions}
                    data={this.getPreparedData()}
                    scheduler={this.schedulerRef}
                    actions={this.actions}
                    currentSlots={this.state.generatedSlots}
                    readonly={slotPlaningReadonly}
                    onOpenInWindow={(openInWindow: boolean) =>
                        this.setState({ openInWindow: openInWindow })}
                    openWorklistInWindow={this.state.openInWindow}
                    skillsEnabled={this.settings.SkillsEnabled}
                    flagsEnabled={Config.settings.flagsAreActive}
                    slaEnabled={Config.user.slaManagementRight}
                    slotSettings={this.slotSearchSettings}
                    interactiveSlotMode={this.state.interactiveSlotModeActive}
                    selectedAssignmentForSlotId={this.state.selectedAssignmentForSlotId}
                    unselectAssignmentForSlot={() => {
                        if (this._refreshing)
                            return;

                        this.settings.DoNotChangeCellWidth = false;
                        this.setState({ interactiveSlotModeActive: true, slotModeActive: false, generatedSlots: [], selectedAssignmentForSlotId: null }, () => {
                            this.settings.DoNotChangeCellWidth = true;
                            if (this.workListRef !== null) {
                                this.workListRef.refreshGrids();
                                this.schedulerRef.refresh(this._getData(), false, () => {
                                    this.workListRef.setState({ showSlotsGrid: false });
                                }).then();
                            }
                        })
                    }}
                />
            );
        }
        else
            return null;
    }

    private getEvent = (eventId: string): ResourcePlanningSchedulerEventViewModel => {
        return this._getData().EventsDict[eventId];
    }

    /*private getResource = (resourceId: string): ResourcePlanningSchedulerResourceViewModel => {
        return this._getData().ResourcesDict[resourceId];
    }*/

    private viewSlotEvent = (event: DayPilot.Event) => {
        //muss da sein!
        const resource = this.state.generatedSlots.filter(r => r.id === event.resource())[0];
        const slotObject = resource.slots.filter(s => s.id === event.id())[0];
        this.openSlot(slotObject, event.resource(), null);
    }

    private acceptSlot = (slot: ResourceSlot, resource: string) => {
        const targetEvent = this._getEventById(this.getSlotModeSourceId());
        let startDate = Helper.dates.toDate(slot.startDate);
        let endDate = Helper.dates.toDate(slot.endDate);

        this.setState({ slotModeActive: false, generatedSlots: [], selectedAssignmentForSlotId: null }, () => {
            this.moveEvent(targetEvent.Id, startDate, endDate, resource, targetEvent.ResourceId, true, false, slot)
                .then(_ => {
                    this.suitableResourcesSearchSettings = null;
                    this.schedulerRef.refresh(this._getData(), false).then();
                    if (slot.wayThere.Kind == JourneyLegKind.Airplane ||
                        slot.wayThere.Kind == JourneyLegKind.AirwayCalculation ||
                        slot.wayBack.Kind == JourneyLegKind.Airplane ||
                        slot.wayBack.Kind == JourneyLegKind.AirwayCalculation)
                        NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.ResourcePlanning.WarnSlotWays"));
                });
        });
    }

    private openAvailableResourceSearch = (eventId: string) => {
        let schedulerStartDate = Helper.dates.toDate(this._getData().SettingsPlanningBoard.Start);
        let schedulerEndDate = Helper.dates.addDays(schedulerStartDate, this._getData().SettingsPlanningBoard.Days - 1);

        if (this.workListRef == null)
            return;

        let slotStartDate = this.workListRef.state.slotStartDate;

        let slotConsiderFlags = this.slotSearchSettings.considerFlags;
        const slotConsiderGroup = this.slotSearchSettings.considerGroup;
        const slotConsiderMainGroup = this.slotSearchSettings.considerMainGroup;
        let slotConsiderSkills = this.slotSearchSettings.considerSkills;
        const slotConsiderGeo = this.slotSearchSettings.considerGeo;
        const slotEnableDebugMode = this.slotSearchSettings.slotEnableDebugMode;
        let slotConsiderSla = this.slotSearchSettings.considerSla;


        if (!this.settings.SkillsEnabled)
            slotConsiderSkills = ConsiderSkillMode.Off;
        if (!Config.settings.flagsAreActive)
            slotConsiderFlags = false;
        if (!Config.user.slaManagementRight)
            slotConsiderSla = false;

        const assignment = this._getEventById(eventId);
        if (!assignment) return;

        const searchConfig: FindAvailableResourcesConfig = {
            percentage: 100,
            startDate: slotStartDate,
            endDate: schedulerEndDate,
            assignmentToDistributeId: Helper.hasValue(assignment) ? assignment.IsGuid : null,
            considerFlags: slotConsiderFlags,
            considerGroup: slotConsiderGroup,
            considerSkills: slotConsiderSkills,
            considerMainGroup: slotConsiderMainGroup,
            considerGeo: slotConsiderGeo,
            considerSla: slotConsiderSla,
            debugMode: slotEnableDebugMode,
            grNrs: this.settings.GrNrs,
            ogrNrs: this.settings.OGrNrs,
            ressNrs: this.settings.RessNrs
        };

        this.findAvailableResources(searchConfig).then(resources => {

            const data: Array<SlotDebugResource> = [];
            if (searchConfig.debugMode) {
                resources.forEach(r => {
                    if ((Helper.hasValue(r.unavailableReasons) && r.unavailableReasons.length > 0)) {

                        const ress: SlotDebugResource = {
                            ressNr: r.ressNr,
                            ressName: r.name,
                            dates: []
                        };

                        let oldDate = null;
                        let dateItem: SlotDebugDates = null;
                        for (let i = 0; i < r.unavailableReasons.length; i++) {
                            const date = r.unavailableReasons[i].date;
                            const reason = r.unavailableReasons[i].reasonCode + ' ' + r.unavailableReasons[i].reason;
                            if (dateItem == null || date != oldDate) {
                                oldDate = date;
                                if (dateItem != null)
                                    ress.dates.push(dateItem);

                                dateItem = {
                                    date: date,
                                    notApplicable: []
                                }
                            }
                            dateItem.notApplicable.push(reason);
                        }
                        if (dateItem != null)
                            ress.dates.push(dateItem);

                        data.push(ress);
                    }
                });
            }

            this.setState({
                selectedAssignmentForSlotId: eventId,
                slotModeActive: true,
                interactiveSlotModeActive: true,
                slotNotApplicableData: data,
                generatedSlots: resources.filter(x => x.id.startsWith("g") || x.slots.length > 0),
            }, () => {
                this.schedulerRef.refresh(this._getData(), false).then(_ => {
                    if (this.state.interactiveSlotModeActive) {
                        this.schedulerRef.markEvent(this.getSlotModeSourceId());
                    }
                });
            });
        });
    }

    private scrollToSlotDebugInfo = (currRess?: string, currDate?: Date) => {
        if (this.state.interactiveSlotModeActive && this.state.slotModeActive && this.slotSearchSettings.slotEnableDebugMode) {
            let element = null;
            let arr = null;
            if (Helper.hasValue(currRess)) {
                arr = currRess.split("|");
                element = document.getElementById("SlotDebugInfo_" + arr[1]);
            }
            if (element != null && Helper.hasValue(currDate)) {
                const elementDate = document.getElementById("SlotDebugInfo_" + arr[1] + "_" + kendo.toString(currDate, 'd'));
                if (elementDate != null)
                    element = elementDate;
            }

            if (element == null) {
                element = document.getElementById("SlotDebugInfo")?.firstElementChild;
                if (element != null)
                    element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                return;
            }
            else
                element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        }
    }

    private findAvailableResources = async (slotSearchConfig: FindAvailableResourcesConfig): Promise<Array<ResourceWithSlots>> => {
        let resourcesWithSlots: Array<ResourceWithSlots> = [];

        if (Helper.hasValue(slotSearchConfig.assignmentToDistributeId))
            resourcesWithSlots = await this._searchForResourceAvailableSlots(slotSearchConfig);

        const containers = this._getData().Resources.filter(r => r.Id.indexOf("g|") === 0);
        containers.forEach(c => {
            resourcesWithSlots.push({
                id: c.Id,
                name: c.Text,
                ressNr: c.Id.split("|")[1],
                slots: [],
                unavailableReasons: null,
            });
        });

        return resourcesWithSlots;
    }

    private _searchForResourceAvailableSlots = async (searchConfig: FindAvailableResourcesConfig): Promise<Array<ResourceWithSlots>> => {
        let slots: Array<ResourceWithSlots> = [];

        await new Promise<Boolean>(async (resolve) => {
            const result = await HTTPService.post<JsonResultClass<Array<ResourceWithSlots>>>("ResourcePlanningScheduler/FindAvailableSlots",
                { searchConfig: searchConfig });

            if (result.Code === 0) {
                if (result.Message != null)
                    NotificationHelper.showWarningMessage(result.Message);
                slots = result.Data;
                resolve(true);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
                resolve(false);
            }
        });

        return slots;
    }


    private handleSchedulerTimeHeaderClicked = (args: any) => {
        let refresh = false;
        const level: number = args.header.level;
        const dateHelper = Helper.dates;
        const sd = dateHelper.toDate(args.header.start.value);
        let startDate: Date | string = this.props.settings.Start;
        let endDate: Date | string = this.props.settings.End;
        let timeType: number = this.props.settings.TimeResolutionType;
        switch (this.props.settings.TimeResolutionType) {
            case (this.timeResolutionTypes.Hours):
                if (level === 0) {
                    startDate = sd;
                    endDate = dateHelper.addDays(sd, 6);
                    timeType = this.timeResolutionTypes.Days;
                    refresh = true;
                }
                break;
            case (this.timeResolutionTypes.Days):
                switch (level) {
                    case (0):
                        startDate = new Date(sd.getFullYear(), sd.getMonth(), 1);
                        endDate = new Date(sd.getFullYear(), sd.getMonth() + 1, 1);
                        endDate = dateHelper.addDays(endDate, -1);
                        refresh = true;
                        break;
                    case (1):
                        startDate = dateHelper.getLastMonday(sd);
                        endDate = dateHelper.addDays(startDate, 6);
                        refresh = true;
                        break;
                    case (2):
                        startDate = sd;
                        endDate = sd;
                        timeType = this.timeResolutionTypes.Hours;
                        refresh = true;
                        this.actions.toggleCapacity(false);
                        break;
                }
                break;
            case (this.timeResolutionTypes.Week):
                switch (level) {
                    case (0):
                        startDate = new Date(sd.getFullYear(), sd.getMonth(), 1);
                        startDate = dateHelper.getLastMonday(startDate);
                        endDate = new Date(sd.getFullYear(), sd.getMonth() + 1, 1);
                        endDate = dateHelper.addDays(endDate, -1);
                        endDate = dateHelper.addDays(dateHelper.getLastMonday(endDate), 6);
                        refresh = true;
                        break;
                    case (1):
                        startDate = dateHelper.getLastMonday(sd);
                        endDate = dateHelper.addDays(startDate, 6);
                        timeType = this.timeResolutionTypes.Days;
                        refresh = true;
                        break;
                }
                break;
            case (this.timeResolutionTypes.Month):
                switch (level) {
                    case (0):
                        startDate = new Date(sd.getFullYear(), 0, 1);
                        endDate = new Date(sd.getFullYear(), 11, 31);
                        refresh = true;
                        break;
                    case (1):
                        startDate = new Date(sd.getFullYear(), sd.getMonth(), 1);
                        startDate = dateHelper.getLastMonday(startDate);
                        endDate = new Date(sd.getFullYear(), sd.getMonth() + 1, 1);
                        endDate = dateHelper.addDays(endDate, -1);
                        endDate = dateHelper.addDays(dateHelper.getLastMonday(endDate), 6);
                        timeType = this.timeResolutionTypes.Week;
                        refresh = true;
                        break;
                }
                this.settings.FlagMode = 0;
                break;
        }
        if (refresh) {
            this.props.settings.Start = dateHelper.getISODateString(startDate);
            this.props.settings.End = dateHelper.getISODateString(endDate);
            this.props.settings.TimeResolutionType = timeType;
            this.doRefresh().then();
        }
    }

    private selectInitialAssignment = () => {
        if (Helper.hasValue(this.props.settings?.InitialProjNr) && Helper.hasValue(this.props.settings?.InitialPIndex)) {
            const showInfoMessage = () => {
                const message = Helper.isNullOrEmpty(this.props.settings.FavoriteFilterId) ? this.translations["Einsatz.Plantafel.NotSelectable"] : Helper.getTranslation("Einsatz.Plantafel.NotInFilter");
                NotificationHelper.showInfoMessage(message)
            }

            const event = this.getEvent(this.props.settings?.InitialProjNr + "|" + this.props.settings.InitialPIndex?.toString());
            if (Helper.hasValue(event)) {
                this.schedulerRef.focusEvent(this.props.settings.InitialProjNr + "|" + this.props.settings.InitialPIndex.toString());
                this.schedulerRef.selectResource(event.ResourceId);// Ressource des Einsatzes scrollen
                if (!this.props.settings.OnlyMarkAssignment) {//Hier open Bedingung einfügen
                    General.Functions.HistoryState.replaceState("ResourcePlanningScheduler")
                    this.openEvent(event.Id, event.ResourceId);
                }
            } else {
                showInfoMessage();
            }
        }
    }

    private afterDiagramLoaded = () => {
        if (this.settings.DisplayCapacityChart)
            setTimeout(() => this.actions.toggleCapacity(true), 0);
    };

    private getlistBoxAssigmentsProps = () => {
        const props = this.factory.getDefaultListBoxProps();
        props.dataSource = this.listTotalItems;
        props.value = this.listRemoveItems;
        props.field.dataTextField = "ProjNr";
        props.field.dataValueField = "Kennung";
        props.field.labelTextLeft = this.translations["WebSMS.ResourcePlanning.NichtVerschiebenEinsatz"];
        props.field.labelTextRight = this.translations["WebSMS.ResourcePlanning.VerschiebenEinsatz"];
        // noinspection CssInvalidHtmlTagReference
        props.field.template = "<style>.listboxProjectElement {border:1px solid black;}<style/><div class=\"listboxProjectElement\"><p>Projektnummer: #=ProjNr# / #=Pindex#</p>  <p> Bemerkung: #=Bemerkung||''#</p> <p>  #=kendo.toString(kendo.parseDate(StartIst), 'g')# - #=kendo.toString(kendo.parseDate(EndeIst), 'g')# </p></div>";
        props.onChange = this.onchangeListBox;
        return props;
    }
    private onchangeListBox = (model: { model: string }, value: any, dataItem: any) => {
        let buttons: JQuery<HTMLElement>;
        // Workaround Updatet sich erst nach den OnChange Event
        let currentItem = this.listTotalItems.filter(x => x.IsGuid === dataItem.IsGuid)[0];
        const selectText = '.k-dialog button.k-button:not(:contains(' + Config.translations.ignore + '))';
        if (this.listboxRef.moveDirectionListBox === 0 && this.listboxRef.moveDirectionListBoxContent !== 1) {
            this.listNotRemoveItems.push(this.listTotalItems.filter(x => x.IsGuid === dataItem.IsGuid)[0]);
            this.listRemoveItems = this.listRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
        } else if (this.listboxRef.moveDirectionListBox === 2 && this.listboxRef.moveDirectionListBoxContent === 2) {
            let index = this.listRemoveItems.indexOf(currentItem) + value;
            this.listRemoveItems = this.listRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
            this.listRemoveItems.splice(index, 0, currentItem);
        }
        else {
            this.listRemoveItems.push(currentItem);
            this.listNotRemoveItems = this.listNotRemoveItems.filter(x => x.IsGuid !== dataItem.IsGuid);
        }
        if (this.listRemoveItems.length === 0) {
            buttons = $(selectText);
            $(buttons).attr('disabled', 'disabled');
        } else {
            buttons = $(selectText);
            $(buttons).removeAttr('disabled');
        }

        if (model) {
            //implicitly warning
        }
    }
    private setBrowserTitle = () => {
        const objects = this.props.metadata.additional.objects;
        let browserTitle: string;
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name === "browserTitle") {
                browserTitle = objects[i].data;
            }
        }
        new AppHelper().updateBrowserTitle(browserTitle);
    }

    private onFocusForward = (searchType: SearchType, value: string) => {
        if (this.focusing.data.length == 0) {
            this.onFocusingChange(searchType, value)
        }
        let index = -1;
        switch (searchType) {
            case "resource":
            case "ressNr":
                index = this.focusing.index + 1;
                if (index >= this.focusing.data.length || (index < 0)) {
                    index = 0;
                }
                let res = this.focusing.data[index];
                if (Helper.hasValue(res)) {
                    this.schedulerRef.selectResource(res.Id, true);
                    this.focusing.index = index;
                }
                break;
            case "adrName":
            case "plz":
            case "projNr":
            case "barText":
                index = this.focusing.index + 1;
                if ((index >= this.focusing.data.length) || (index < 0)) {
                    index = 0;
                }
                const event = this.focusing.data[index];
                this.markEventByFocusing(event, index)
                break;
        }
    }

    private onFocusBackward = (searchType: SearchType) => {
        let index = -1;
        switch (searchType) {
            case "resource":
            case "ressNr":
                index = this.focusing.index - 1;
                if (index < 0) {
                    index = this.focusing.data.length - 1
                }
                let res = this.focusing.data[index];
                if (Helper.hasValue(res)) {
                    this.schedulerRef.selectResource(res.Id, true);
                    this.focusing.index = index;
                }
                break;
            case "projNr":
            case "adrName":
            case "plz":
            case "barText":
                index = this.focusing.index - 1;
                if (index < 0) {
                    index = this.focusing.data.length - 1
                }
                const event = this.focusing.data[index];
                this.markEventByFocusing(event, index)
                break;
        }
    }

    private markEventByFocusing = (event: any, index: number) => {
        if (Helper.hasValue(event)) {
            this.schedulerRef.focusEvent(event.Id);
            this.focusing.index = index;
        }
    }

    private onFocusingChange = (searchType: SearchType, value: string) => {
        const sort = (a: ResourcePlanningSchedulerEventViewModel, b: ResourcePlanningSchedulerEventViewModel) => {
            //level 1
            //nach name
            if (a.ResourceName < b.ResourceName) {
                return -1;
            } else if (a.ResourceName > b.ResourceName) {
                return 1;
            } else {
                //level 2 
                //nach start
                if (a.StartPilotDate < b.StartPilotDate) {
                    return -1;
                } else if (a.StartPilotDate > b.StartPilotDate) {
                    return 1;
                } else {
                    return 0;
                }
            }
        }

        let lst1: ResourcePlanningSchedulerResourceViewModel[];
        switch (searchType) {
            case "resource":
                lst1 = this._getData().Resources.filter(f => f.Id.indexOf("r|") > -1);
                this.focusing = {
                    data: lst1.filter(f => f.Text?.toLowerCase().indexOf(value.toLowerCase()) > -1),
                    index: -1,
                    searchType: searchType,
                    value: value
                }
                break;
            case "ressNr":
                lst1 = this._getData().Resources.filter(f => f.Id.indexOf("r|") > -1);
                this.focusing = {
                    data: lst1.filter(f => f.Id.toString().toLowerCase().indexOf(value.toLowerCase()) > -1),
                    index: -1,
                    searchType: searchType,
                    value: value
                }
                break;
            default:
                let lst = this._getData().Events
                switch (searchType) {
                    case "projNr":
                        lst = lst.filter(f => f.Id.toLowerCase().indexOf(value.toLowerCase()) > -1);
                        break;
                    case "adrName":
                        lst = lst.filter(f => !Helper.isNullOrEmpty(f.AdrName) && f.AdrName.toLowerCase().indexOf(value.toLowerCase()) > -1);
                        break;
                    case "plz":
                        lst = lst.filter(f => !Helper.isNullOrEmpty(f.AdrPlz) && f.AdrPlz.toLowerCase().indexOf(value.toLowerCase()) > -1);
                        break;
                    case "barText":
                        lst = lst.filter(f => !Helper.isNullOrEmpty(f.Text) && f.Text.toLowerCase().indexOf(value.toLowerCase()) > -1)
                        break;
                }
                lst = lst
                    .filter(f => f.ResourceId.indexOf("r|") > -1)
                    .sort(sort)
                    .concat(lst.filter(f => f.ResourceId.indexOf("g|") > -1).sort(sort));
                this.focusing = {
                    data: lst,
                    index: -1,
                    searchType: searchType,
                    value: value
                }
                break;

        }
    }

    private getPreparedData = (): ResourcePlanningSchedulerDataViewModel => {
        let result: ResourcePlanningSchedulerDataViewModel = JSON.parse(JSON.stringify(this._getData()));
        if (this.state.interactiveSlotModeActive) {
            // Containereinsätze ohne Schreibrechte und ohne TargetHours wegfiltern
            result.Events = result.Events.filter(f => f.ResourceId.startsWith("r") || (f.RecordRight.CanWrite
                 /* && f.TargetHours !== null */));
        }


        result.Events = result.Events.filter((value, index, self) => {
            return self.findIndex(event => event.Projnr == value.Projnr && event.Pindex == value.Pindex) === index;
        })

        return result;
    }

    private afterSchedulerLoaded = () => {
        if (!Helper.isNullOrEmpty(this.settings.InitalResource) && Helper.hasValue(this.schedulerRef)) {
            //console.log("Start scheduler loaded");
            this.schedulerRef.selectResource(this.settings.InitalResource);
        }
    }

    private setFavoriteFilter = async (settings: ResourcePlanningSchedulerSettingsViewModel) => {
        if (settings == null) //update caption 
        {
            this.setState({});
            return;
        }
        if (Config.user.activeExtendedProjectFilter && this.props.settings.ActiveExtendedProjectFilter) {
            const extendedProjFilter = Helper.loadDataFromStorage(Config.user.userName + "_ExtProjFilter");
            if (extendedProjFilter) {
                let projNrs = extendedProjFilter.filter((e: any): any => e.Active).map((e: any): any => e.ProjNr);
                if (projNrs.length > 0) {
                    if (Helper.hasValue(settings.FavoriteFilterId)) {
                        NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ProjNrsDeactivated"));
                    } else {
                        settings.ProjNrs = projNrs;
                        settings.ProjNrsHistory = extendedProjFilter;
                        NotificationHelper.showInfoMessage(Helper.getTranslation("Field.Projekt.ExtendedProjectFilter.ProjNrsReactivated"));
                    }
                }
            }
        }
        const ignoredKeys = ["Flags"];
        Object.keys(this.props.settings).filter(key => ignoredKeys.findIndex(ig => ig == key) == -1).forEach((key) => {
            this.props.settings[key] = settings[key];
        });
        if (this.props.settings.DisplayGeomapMap) {
            this.openInPlanningBoard();
        }
        this.geomapViewMode = settings.DisplayGeomapMap ? GeomapViewMode.StandardView : GeomapViewMode.None;
        return await this.doRefresh(null, 0, true, true, true);
    }

    private checkSlotModeSourceId(id: string): string {
        if (id == null)
            return null;

        const ev = this._getEventById(id);
        if (ev == null || !ev.ResourceId.startsWith("g") || !ev.RecordRight.CanWrite)
            return null;

        return id;
    }

    private getSlotModeSourceId() {
        const id = this.workListRef !== null &&
            Helper.hasValue(this.state.selectedAssignmentForSlotId) &&
            this.state.interactiveSlotModeActive &&
            this.state.slotModeActive ? this.state.selectedAssignmentForSlotId : null;
        //console.log("getSlotModeSourceId=" + id);
        return this.checkSlotModeSourceId(id);
    }

    private printScheduler = () => {
        const oldHeightSpec = this.schedulerRef.getDps().heightSpec;
        const needUpdateDsp = oldHeightSpec != "Auto";

        const dps = this.schedulerRef.getDps();

        Helper.setBusyIndicator(true).then(_ => {

            const scrollY = dps.getScrollY();
            const scrollX = dps.getScrollX();

            if (needUpdateDsp) {
                dps.heightSpec = "Auto";
            }

            dps.update({ scrollY: 0, scrollX: 0 });
            dps.show();

            let draw = kendo.drawing;
            let geom = kendo.geometry;


            const dpsDiv = this.schedulerRef.getPilotDiv();

            draw.drawDOM(dpsDiv as any, {})
                .then(function (root) {

                    let imageSize = new geom.Rect([0, 0], [dpsDiv.scrollWidth,
                    dpsDiv.scrollHeight]);

                    let background = draw.Path.fromRect(imageSize, {
                        fill: {
                            color: "#ffffff",
                        },
                        stroke: null
                    });

                    let wrap = new draw.Group();
                    wrap.append(background, root);

                    return draw.exportImage(wrap);
                })
                .done(function (data) {
                    if (needUpdateDsp)
                        dps.heightSpec = oldHeightSpec;

                    dps.update({ scrollY: scrollY, scrollX: scrollX });
                    dps.show();

                    Helper.setBusyIndicator(false).then();
                    kendo.saveAs({
                        dataURI: data,
                        fileName: "calendar.png"
                    });
                }).fail(function () {
                    Helper.setBusyIndicator(false).then();
                }).then(_ => { })
        });
    }

    componentWillUnmount() {
        if (this.geomapRpcService != null && !this.geomapRpcService.isDisconnected()) {
            this.geomapRpcService.stop();
        }
    }

    componentDidMount() {
        //console.log("resourcePlanningScheduler - componentDidMount");
        if (this.settings.DisplayWorkListInTable)
            this.actions.toggleWorklistInTable(true);
        if (this.settings.DisplayGeomapMap)
            this.actions.toggleGeomap();

        /*if (this.refreshAfterComponentDidMount) { // Funktioniert mit Firefox 80 sonst nicht!?
            setTimeout(() => {
                this.doRefresh(this.props.settings.InitialProjNr, this.props.settings.InitialPIndex, false).then();
            });
        }*/
    }

    render() {
        const listBoxAssigmentsProps = this.getlistBoxAssigmentsProps();
        const data = this._getData();
        const titles: string[] = [];

        if (!this.props.settings.AutoUpdateScheduler) {
            const autoUpdate = Helper.getTranslation("Einsatz.Einstellungen.AutoUpdateScheduler");
            const disabled = Helper.getTranslation("Standard.Deaktiviert");
            titles.push(autoUpdate + ": " + disabled.toLowerCase());
        }


        if (this.state.multiSelectActive) {
            if (this.state.multiSelectEvents.length > 0)
                titles.push(this._captionMultiSelect + ": " + this.state.multiSelectEvents.length);
            else
                titles.push(this._captionMultiSelect);
        }

        if (this.state.interactiveSlotModeActive) {

            const id = this.getSlotModeSourceId();

            if (id != null) {
                titles.push(this._captionInteractiveSlotMode + ": " + id.replace("|", "/"));

                const lst = this.state.generatedSlots.filter(x => x.slots.length > 0 &&
                    this._getData().Resources.find(r => r.Id == "r|" + x.ressNr));

                let count = 0;
                let slotCount = 0;
                if (lst.length > 0) {
                    count = lst.length;
                    for (let i = 0; i < lst.length; i++) {
                        slotCount += lst[i].slots.length;
                    }
                }

                if (count > 0)
                    titles.push(this._captionRessSlotFound + ": " + count + "/" + slotCount)
                else
                    titles.push(this._captionRessSlotNotFound);
            }
            else
                titles.push(this._captionInteractiveSlotMode);
        }

        const titleEx = titles.length > 0 ? " (" + titles.join(", ") + ")" : "";

        return (
            <FullHeightContainer classes={"sheet flex-container--row resource-planning-container"}>
                <style>
                    {this.props.settings.AllWeekendDays.map((item) => { return `.${SchedulerClasses.WeekEndSchema + item.Id + "_" + item.DayOfWeek} { background-color: ${item.Color};}` })}
                    {`.${SchedulerClasses.WeekEnd} { background-color: ${data.SettingsPlanningBoard.BackgroundColorWeekEnd}; }`}
                    {`.${SchedulerClasses.CurrentDay} { background-color: ${data.SettingsPlanningBoard.BackgroundColorToday}; }`}
                    {`.${SchedulerClasses.FreeDay} { background-color: ${data.SettingsPlanningBoard.BackgroundColorFreeDay}; }`}
                    {`.${SchedulerClasses.Overload}  { background-color: #ef5350 !important; }`}
                    {`.${CapacityColorClasses.Absent} { background-color: ${data.CapacitySettings.ColorAbsent}; }`}
                    {`.${CapacityColorClasses.Assignment} { background-color: ${data.CapacitySettings.ColorAssignment}; }`}
                    {`.${CapacityColorClasses.External} { background-color: ${data.CapacitySettings.ColorExternal}; }`}
                    {`.${CapacityColorClasses.Internal} { background-color: ${data.CapacitySettings.ColorInternal}; }`}
                    {`.${CapacityColorClasses.Overload} { background-color: ${data.CapacitySettings.ColorOver}; }`}
                    {/*`.${SchedulerResourceHeaderClasses.NameColumn}.${SchedulerResourceHeaderClasses.External} { background-color: ${this._data.SettingsPlanningBoard.BackgroundColorExternalResource}; color: white; }`*/}
                    {/*{`.${SchedulerResourceHeaderClasses.Selected} .${SchedulerResourceHeaderClasses.NameColumn} { background-color: #7de7f6; color: #666666; }`}*/}
                    {`.${SchedulerResourceHeaderClasses.Selected} { background-color: #7de7f6; color: #666666; }`}
                    {/*`.${SchedulerResourceHeaderClasses.Selected} .${SchedulerResourceHeaderClasses.NameColumn}.${SchedulerResourceHeaderClasses.External} { color: white; }`*/}
                    {`.${SchedulerResourceHeaderClasses.Overload} { background-color: #ef5350; color: white; }`}
                </style>
                <PageTitle title={this.props.title + titleEx} />
                {this.renderRightDrawerComponent()}
                <Settings ref={(r) => this.settingsRef = r}
                    settings={this.settings}
                    data={data}
                    actions={this.actions}
                    dataSources={this.props.dataSources}
                    translations={this.translations}
                    onChange={this.handleChangeFilterField}
                    commandManager={this.common.commandManager}
                    enableHiddenEventsForCapacityToggle={this.settings.DisplayCapacityChart}
                    gmToggleButtonValue={this.geomapViewMode !== GeomapViewMode.None}
                    capacityActive={this.settings.DisplayCapacityChart}
                    interactiveSlotModeActive={this.state.interactiveSlotModeActive}
                    onGraphicalFocussingChange={{ onBackward: this.onFocusBackward, onChange: this.onFocusingChange, onForward: this.onFocusForward }}
                    multiSelectEvents={this.state.multiSelectEvents}
                    openExternalInfos={this.openExternalInfos}
                    onFavoriteFilterChange={this.setFavoriteFilter}
                    dropDownFilterOptions={this.dropDownFilterOptions}
                    deprecatedDelphiMode={this.deprecatedDelphiMode}
                    handleEval={this.common.evalAction}
                />
                <RSplitter direction={RSplitterDirection.Vertical} initialPercentage={80} afterResize={() => { this.schedulerRef.getDps().show(); }} rememberPercentage={true} id={"workListSplitter"}
                    shouldHideSecondContainer={() => this.state.openInWindow}>
                    <div className="flex-container__item flex-container" style={{ /*kendo fix... */ zIndex: 0 }}>
                        <RSplitter direction={RSplitterDirection.Horizontal} initialPercentage={65} shouldHideSecondContainer={() => this.geomapConfig && this.geomapViewMode === GeomapViewMode.None}>
                            <div className="flex-container__item flex-container" style={{ /*kendo fix... */ zIndex: 1, overflow: "hidden" }} key="scheduler-xa">
                                <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                                    <div data-resource-planning-scheduler-navigation="1" />
                                    {this.deprecatedDelphiMode ? < Legend settings={this.settings} onChange={this.handleChangeFilterField} events={this._getData().Events} /> : null}
                                </div>
                                <Scheduler ref={(r) => { if (Helper.hasValue(r)) this.schedulerRef = r }}
                                    settings={this.settings}
                                    lookups={this.props.lookups}
                                    actions={this.actions}
                                    initialData={this._initData}
                                    translations={this.translations}
                                    selectedResourceChanged={this.handleSelectedResourceChanged}
                                    selectedEventChanged={this.handleSelectedEventChanged}
                                    selectedTimeRangeChanged={this.handleSelectedTimeRangeChanged}
                                    onPartialRefresh={this.handlePartialRefresh}
                                    timeHeaderClicked={this.handleSchedulerTimeHeaderClicked}
                                    currentSlots={this.state.generatedSlots}
                                    slotModeActive={this.state.slotModeActive}
                                    slotModeSourceId={this.state.selectedAssignmentForSlotId}
                                    geomapViewMode={this.geomapViewMode}
                                    geomapRouteColors={this.state.geomapRouteColors}
                                    multiSelectActive={this.state.multiSelectActive}
                                    afterSchedulerLoaded={this.afterSchedulerLoaded}
                                    initialResource={this.props.settings.InitalResource}
                                    afterDiagramLoaded={this.afterDiagramLoaded}
                                    templateFunc={this.state.templateFunc}
                                    hintTemplateFunc={this.state.hintTemplateFunc}
                                    slotSearchSettings={this.slotSearchSettings}
                                    columnTemplate={this.columnTemplate}
                                />
                                {
                                    this.state.showDialog ?
                                        <Dialog ref={this.setDialogRef} title={this.translations["WebSMS.ResourcePlanning.FolgendeEinsaetze"]}
                                            actions={this._dialogActions} open={true} afterClose={this.closeDialog}>
                                            <div style={{ width: "800px", height: "450px" }}>
                                                <label>{this.translations["WebSMS.ResourcePlanning.WaehleEinsaetze"]}</label>
                                                <FieldInstance noHover={true} noLabel={true}>
                                                    <ListBox ref={this.setListBoxRef}{...listBoxAssigmentsProps} />
                                                </FieldInstance>
                                            </div>
                                        </Dialog>
                                        : null
                                }
                            </div>
                            {this.renderGeomap()}
                        </RSplitter>
                    </div>
                    {this.renderWorklist()}
                </RSplitter>
                <Menu {...this.menuProps} />

                <EntityReminders />
                <BookmarkBtn contextType={"scheduler"} />
            </FullHeightContainer>
        );
    }
}
export enum GeomapViewMode {
    None, StandardView, ResourceView
}
interface ResourcePlanningSchedulerState {
    //slots
    //check box => checked
    interactiveSlotModeActive: boolean;
    //true, after real slot search
    slotModeActive: boolean;
    //selected id in grid
    selectedAssignmentForSlotId: string;
    //slots data
    generatedSlots: Array<ResourceWithSlots>;
    slotNotApplicableData: Array<any>;

    showDialog: boolean;
    slaModeActive: boolean;
    assigmentGroupingModeActive: boolean;
    geomapRouteColors?: Array<RouteColors>;
    movedGroupingArray: any[];
    multiSelectActive: boolean;
    multiSelectEvents: Array<ResourcePlanningSchedulerEventViewModel>;
    templateFunc: (data: any) => string;
    hintTemplateFunc: (data: any) => string;
    openInWindow: boolean;
    slotEnableDebugMode: boolean;
}

export interface ResourcePlanningSchedulerActions {
    doRefresh: () => void;
    deleteEvent: (id: string) => void;
    copyEvent: (id: string, newStart: Date, newEnd: Date, newResourceId: string) => void;
    splitEvent: (id: string, newResourceId: string) => void;
    copyToResources: (id: string,) => void;
    splitToResources: (id: string,) => void;
    moveEvent: (id: string, newStart: Date, newEnd: Date, newResourceId: string, oldResourceId: string, resizeAction: boolean, byDelta: boolean) => void;
    openEvent: (id: string, resourceId: string) => void;
    newFromResource: (resourceId: string) => void;
    newPMFromResource: (resourceId: string) => void;
    openResource: (resourceId: string) => void;
    openProject: (projNr: string) => void;
    filterByProjNr: (projNr: string) => void;
    addProjNr: (projNr: string) => void;
    newFromSelection: (resourceId: string, start: Date, end: Date) => void;
    newPMFromSelection: (resourceId: string, start: Date, end: Date) => void;
    calculateRoute: (id: string) => void;
    calculateTravelTimes: (id: string) => void;
    signalIgnoreProjectFilterInCapacity: (use: boolean, doRefresh: boolean) => void;
    toggleGeomap: () => void;
    updateSlotSettings: (settings: SlotSearchSettings) => void;
    toggleCapacity: (isOn: boolean) => void;
    toggleWorklistInTable: (isOn: boolean, afterUpdate?: Function) => void;
    toggleInteractiveSlotMode: (isOn: boolean) => void;
    slotWorkListChanged: () => void;
    toggleSlaView: (isOn: boolean, doRefresh: boolean) => void;
    toggleFlagView: (mode: 0 | 1 | 2, doRefresh: boolean) => void;
    toggleAssigmentGroupingView: (isOn: boolean) => void;
    focusEvent: (id: string) => void;
    focusSlotEvent: (id: string) => void;
    markEvent: (id: string) => void;
    fitToWorkingTime: (id: string, resourceId: string) => void;
    assignAreaToResource: (flagId: any, ressNr: string, start: string | Date, end: string | Date) => void;
    removeFlagsFromResource: (ressNr: string, start: string | Date, end: string | Date) => void;
    openSlot: (event: DayPilot.Event) => void;
    useSlot: (ressource: string, slot: ResourceSlot) => void;
    computeSlots: (event: string) => void;
    newAssigmentGrouping: (id: string) => void;
    deleteAssigmentGrouping: (id: string) => void;
    listAssigmentGrouping: (id: string) => void;
    changeAssigmentGrouping: (id: string) => void;
    changeToLastAssigmentGrouping: (id: string, last: number) => void;
    toggleMultiSelect: (isOn: boolean) => void;
    multiSelectEventsSelected: (events: Array<ResourcePlanningSchedulerEventViewModel>) => void;
    executeMultiSelectAction: (action: MultiSelectAction) => void;
    executeMultiSelectFixing: (action: "fix" | "defix", fixMode: FixMode) => void;
    processAssigmentGroupingList: (action: MultiSelectAction) => void;
    addFlagToAssignments: (flagId: string, assignmentsIds: string[]) => void;
    removeFlagsFromAssignments: (assignmentsIds: string[]) => void;
    moveAssignmentByDelta: (assignmentsId: string, delta: number) => void;
    changeStatusSend: (newStatusSend: number) => void;

    toggleFixedStart: (event: ResourcePlanningSchedulerEventViewModel) => void;
    toggleFixedEnd: (event: ResourcePlanningSchedulerEventViewModel) => void;
    toggleFixedResource: (event: ResourcePlanningSchedulerEventViewModel) => void;

    toggleProvisional: (event: ResourcePlanningSchedulerEventViewModel) => void;
    toggleHalfDay: (event: ResourcePlanningSchedulerEventViewModel) => void;

    changeSendState: (event: ResourcePlanningSchedulerEventViewModel, sendState: number) => void;
    setContainerFilterId: (id: number) => void;
}
interface ResourcePlanningSchedulerAppProps {
    title: string;
    settings: ResourcePlanningSchedulerSettingsViewModel;
    lookups: any;
    data: ResourcePlanningSchedulerDataViewModel;
    dataSources: { resstypenDS: any };
    metadata: Metadata;
}

interface ResourcePlanningSchedulerDisplaySettings {
    ShowOnlyWorktime: boolean;
    ShowAssignmentsWithTimeZones: boolean;
    ShowProjectColor: boolean;
    FlagMode: 0 | 1 | 2;

    AssignmentMoveVerticalFixed: boolean;
    AssignmentMoveHorizontalFixed: boolean;

    DisplayWorkListInTable: boolean;
    DisplayGeomapMap: boolean;
    DisplayCapacityChart: boolean;

    GroupByResources: boolean;
    GroupByAddresses: boolean;
    GroupByProjects: boolean;
    GroupByMachines: boolean;

    WholeDayAssignmentRendering: boolean;
    SlaViewActive: boolean;
    ShowUtilization: boolean;
    ShowTargetPeriods: boolean;
    ShowDegreeOfCompletion: boolean;

    AssignmentGroupingViewActive: boolean;

    CapacityIgnoreProjectFilter: boolean;
    ProjectFilterShowAllAssignments: boolean;
}

interface ResourcePlanningSchedulerSlotSettings {
    SlotRespectSlotResourceFilter: boolean;
    SlotEnableDebugMode: boolean;
    ConsiderFlags: boolean;
    ConsiderMainGroup: boolean;
    ConsiderGroup: boolean;
    ConsiderSkills: 0 | 1 | 2;
    ConsiderGeo: 0 | 1 | 2;
    ConsiderSla: boolean;
}

export interface ResourcePlanningSchedulerSettingsViewModel {
    ShowProfilePicture: boolean;
    Start: string;
    End: string;
    InitialProjNr: string;
    InitialPIndex?: number;
    ProjNr: string;
    PIndex?: number;
    Geomap_Enabled: boolean;
    TimeResolutionType: number;
    OGrNrs: number[];
    GrNrs: number[];
    Resstand: string[];
    Resstand_Enabled: boolean;
    FlagFilter_Enabled: boolean;
    IconFilter_Enabled: boolean;
    GrOGrCombinations: any[];
    ProjNrs: string[];
    ProjNrsHistory: ProjectFilterHistoryItem[];
    ActiveExtendedProjectFilter: boolean;
    RessNrs: string[];
    AdrNrs: string[];
    Status: number[];
    KNrs: number[];
    FilterCodesOnlyInContainers: boolean;
    KNrs_Enabled: boolean;
    KNrGroups: string[];
    KNrGroups_Enabled: boolean;
    Legend: {
        Entries: ResourcePlanningSchedulerLegendEntryViewModel[];
    };
    Restypes?: number[];
    FilteredFlags?: string[];
    FilterFlagOnlyInContainer?: boolean;
    ConsiderFlagsForTimePeriod?: boolean;
    FilteredIcons?: string[];
    SendStates: any[];
    Restypes_Enabled: boolean;
    ResourceStatusEnabled: boolean;
    FilterResourcesWithEvents: boolean;
    FilterContainerWithEvents: boolean;
    ShowProjectColor: boolean;
    ShowProjectColor_Enabled: boolean;
    AssignmentMoveVerticalFixed: boolean;
    AssignmentMoveHorizontalFixed: boolean;
    AutoUpdateScheduler: boolean;
    ShowExternalResources: boolean;
    HideExternalResources_Enabled: boolean;
    SkillsEnabled: boolean;
    SkillsToFilter: Array<SkillCategory>, //string, //SkillsAndCapacityFilterData;
    ShowAssignmentsWithTimeZones_Enabled: boolean;
    ShowAssignmentsWithTimeZones: boolean;
    ReadOnlyScheduler: boolean
    CreateAssignmentWithPM_Enabled: boolean;
    IsMobileDevice: boolean;
    //AutoRefreshWholeSchedulerAfterChange: boolean;
    FixedCellWidth: boolean;
    NumberOfLinesInEvent: number;
    HeightOfResourceInfo: number;
    SelectedFilterGuid: string;
    ShowOnlyWorktime: boolean;
    GeomapFilterRouteResultGraduation?: Array<any>;//Array<GeoMapRouteResultGraduation>, export
    DisplayCapacityChart: boolean;
    CapacityIgnoreProjectFilter: boolean;
    DisplayGeomapMap: boolean;
    DisplayWorkListInTable: boolean;
    WholeDayAssignmentRendering: boolean;
    GroupByResources: boolean;
    GroupByAddresses: boolean;
    GroupByProjects: boolean;
    GroupByMachines: boolean;
    SlaViewActive?: boolean;
    FlagMode?: 0 | 1 | 2;
    Flags?: any[];
    HatcheWeekEndInFlagView?: boolean;
    HatcheHolidayInFlagView?: boolean;
    AdditionalDatesAtMove?: boolean;
    DateFormatAtMoving?: string;
    Overlapping?: number;
    ShowUtilization: boolean;
    ShowTargetPeriods: boolean;
    ShowDegreeOfCompletion: boolean;
    DoNotChangeCellWidth: boolean;
    AssignmentEditingTiedToProjectStatus: boolean;
    AssignmentGroupingViewActive?: boolean;
    InitalResource?: string;
    SplitUpAndCutAssignment?: boolean;
    OnlyMarkAssignment?: boolean;
    OnlyContainerAssignments?: boolean;
    SortProjectsAfterEnd?: boolean;
    AssignmentGroupingActive?: boolean;
    CopyRessourceGroupingActive?: boolean;
    AllWeekendDays: Array<WeekendDay>;
    ShowFreeWeekeend: boolean;
    FavoriteFilterId: string;
    CellWidth: any;
    IgnoreUtilTravelTimes: boolean;
    CodeCounterMode: number;
    ActiveKendoTemplate: PlanningBoardTemplate;
    ResourceStatusSetting: ResourceStatusSetting;
    ShowProjectStructure?: boolean;
    ContainerFilterId: number;
    AssignmentSorting: SortingInfo[];
    ResourceFilterExclusive: boolean;
    OnlyUnfinished: boolean;
    ProjectFilterShowAllAssignments: boolean;
    ProjektfilterAlleEinsaetzeAnzeigen: any;
}

export enum ResourceStatusSetting {
    All = 0,
    Active = 1,
    Inactive = 2
}

interface PlanningBoardTemplate {
    Id: string;
    Title: string;
    Template: string;
    HintTemplate: string;
}

export interface WeekendDay {
    Id: number;
    DayOfWeek: number;
    DayOfWeekTranslation: string;
    ReplacesSaturday: boolean;
    ReplacesSunday: boolean;
    Color: string;
    Description: string;
}

export interface ResourcePlanningSchedulerDataViewModel {
    Resources: ResourcePlanningSchedulerResourceViewModel[];
    ResourcesDict: StringKeyDictionary<ResourcePlanningSchedulerResourceViewModel>;
    Events: ResourcePlanningSchedulerEventViewModel[];
    EventsDict: StringKeyDictionary<ResourcePlanningSchedulerEventViewModel>;
    Freedays: ResourcePlanningSchedulerFreedayViewModel[];
    SettingsPlanningBoard: ResourcePlanningSchedulerSettingsPlanningBoardViewModel;
    CapacitySettings: ResourcePlanningSchedulerCapacitySettings;
    Projects: { ProjNr: string; Ende: string, LevelCode?: string }[];
    AllWeekendDays: Array<WeekendDay>;
    RosterDayInfos: Array<RosterDayInfoViewModel>;
}
export function GetRosterInfoFromArray(rosterDayInfos: Array<RosterDayInfoViewModel>, resourceRDI: number[], day: number): RosterDayInfoViewModel {
    if (resourceRDI.length == 0)
        return null;
    const id = resourceRDI[day];
    return rosterDayInfos[id];
}

export interface RosterDayInfoViewModel {
    t: number;
    wp: number;
    w: number;
    c: number;
}

enum RosterDay {
    None = 0,
    IsWeekend = 1,
    IsHoliday = 2,
    IsHalfHoliday = 3
}

export function IsHoliday(data: RosterDayInfoViewModel): boolean {
    return (data.t & RosterDay.IsHoliday) === RosterDay.IsHoliday;
}
export function IsHalfHoliday(data: RosterDayInfoViewModel): boolean {
    return (data.t & RosterDay.IsHalfHoliday) === RosterDay.IsHalfHoliday;
}
export function IsWeekend(data: RosterDayInfoViewModel): boolean {
    return (data.t & RosterDay.IsWeekend) === RosterDay.IsWeekend;
}

export interface ResourcePlanningSchedulerResourceViewModel {
    Id: string;
    Text: string;
    TmpGr?: number;
    HoursPerDay?: number;
    KalenderId?: number;
    Columns: string[];
    BackGroundColor: string;
    FontColor: string;
    CanWrite: boolean;
    Grnr: number;
    Ogrnr: number;
    WochenendId: number;
    RosterDayInfo: number[];
    Bis: Date;
    Seit: Date;
    ImageDocGuid: string;
    BisAsPilotDay: DayPilot.Date;
    SeitAsPilotDay: DayPilot.Date;
}

// noinspection JSUnusedGlobalSymbols
export interface RecordRightEinsatzViewModel {
    IsGuid: string;
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
    }
}

export interface ResourcePlanningSchedulerEventViewModel {
    Id: string;
    CreatedBy: string;
    IsReadOnly: number;
    KNr: number;
    Projnr: string;
    Pindex: number;
    Start: string;
    FixStart: number;
    SendStatus: number;
    End: string;
    FixEnd: number;
    Text: string;
    Hint: string;
    ResourceId: string;
    FixResource: number;
    ForeColor: string;
    BackgroundColor: string;
    BorderColor: string;
    KennungTyp: Kennungstyp;
    IsHalfDay: boolean;
    Wochenende: number;
    Arbeitszeit: number;
    Hidden: boolean;
    ProjectStatus?: {
        Nr?: number;
        Planung?: number;
    };
    OGrNr?: number;
    GrNr?: number;
    MainGroupCalendarId?: number;
    LocationTimeZoneId?: number;
    StatusMarkingCode: string;
    StatusMarkingColor: string;
    WorkStart: string;
    WorkEnd: string;
    IsAnnonymous: boolean;
    Title: string;
    ResourceName: string;
    MainGroupName?: string;
    AdrNr: string;
    AdrName: string;
    AdrCity: string;
    AdrPlz: string;
    AdrCountry: string;
    TargetHours: number;
    IsGuid?: string;

    ContinuationJourney: boolean;
    EpochStart: number;
    EpochEnd: number;
    EpochWorkStart: number;
    EpochWorkEnd: number;
    ProjKennwort: string;
    SlaLevelDate: string;
    SlaLevelTitle: string;
    PMValues: ProjectManagementValues;
    //Utilization: number;
    Complete: number;
    RecordRight: {
        CanRead: boolean;
        CanWrite: boolean;
    }
    Gruppierung: number;
    Prioritaet: number;
    Provisional: boolean;
    MaschNr: string;
    MaschName: string;

    AllowContextMenu: boolean;

    IconInfo: {
        HexCode: string,
        Color: string
    }

    AssignmentUtilizationInfo: AssignmentUtilizationInfo;
    WayThere?: TraveldataModel;
    WayBack?: TraveldataModel;
    Holiday: boolean;

    FlagId: string;
    NotificationState: PushNotificationState;
    UsesApp?: boolean;
    UsesWindowClient?: boolean;
    Datenpaket: string;
    IsSendToMobileApp: boolean;
    StartPilotDate: DayPilot.Date;
    EndPilotDate: DayPilot.Date;
}

export enum Kennungstyp {
    Urlaub = 1,
    Fehlzeit = 2,
    Adressbezogen = 4,
    Projektbezogen = 5,
    Wartung = 6,
    InterneZeiten = 7
}

export enum AssignmentType {
    Absent, Intern, Work
}

export function IsAbsent(kennungTyp?: Kennungstyp): boolean {
    return (kennungTyp === Kennungstyp.Urlaub || kennungTyp === Kennungstyp.Fehlzeit);
}

export function IsInternal(kennungTyp?: Kennungstyp): boolean {
    return (kennungTyp === Kennungstyp.InterneZeiten);
}

export function IsEventType(event: ResourcePlanningSchedulerEventViewModel): AssignmentType {
    if (IsAbsent(event?.KennungTyp))
        return AssignmentType.Absent;
    if (IsInternal(event?.KennungTyp))
        return AssignmentType.Intern;
    return AssignmentType.Work;
}

export interface PushNotificationState {
    State: string;
    IsRowId: number;
    Description: string;
    Icon: string;
}


export interface AssignmentGroupingView {
    projNr: string;
    pIndex: number;
}

export interface ProjectManagementValues {
    StartSoll: string;
    EndeSoll: string;
    Btyp: number;
}

export interface ResourcePlanningSchedulerFreedayViewModel {
    KalenderId: number; // -1 -> !InnosoftApplication.Einstellungen.SpezialkalenderAktiviert, sonst KalenderId
    Day: string; // dd.MM.yyyy
    DayAsPilotDate: DayPilot.Date;
    Name: string;
    Color: string;
    IsHalfDay: boolean;
}

export interface ResourcePlanningSchedulerSettingsPlanningBoardViewModel {
    RowHeaderColumns: ResourcePlanningSchedulerSettingsPlanningBoardColumnViewModel[];
    GroupByColumns: string[];
    GroupByProjectColumns: string[];
    EventMoveHandling: 'CallBack' | 'Disabled';
    EventResizeHandling: 'CallBack' | 'Disabled';
    Units: number;
    CellWidth: number;
    TimeHeaders: ResourcePlanningSchedulerSettingsPlanningBoardTimeHeaderViewModel[];
    Scale: "Hour" | "Day" | "Week" | "Month";
    Days: number;
    Start: string;
    End: string;
    BackgroundColorExternalResource: string;
    MarkFixedDelegations: boolean;
    SpecialCalendarActivated: boolean;
    NextDate: string;
    NextEndDate: string;
    PrevDate: string;
    PrevEndDate: string;

    NextCustomDate: string;
    NextCustomEndDate: string;
    PrevCustomDate: string;
    PrevCustomEndDate: string;

    Today: string;
    TodayEndFrameDate: string;
    ZoomInStartDate: string;
    ZoomInEndDate: string;
    ZoomOutStartDate: string;
    ZoomOutEndDate: string;
    BackgroundColorFreeDay: string;
    BackgroundColorWeekEnd: string;
    BackgroundColorToday: string;
    EpochStart: number;
    EpochEnd: number;
    GantColoring?: {
        RessNr: string,
        Day: Date | string,
        Id: string,
        FlagColor: string,
        FlagName: string,
        FlagId: string
    }[];

    AssignmentGorupingAcive: boolean;
    RenderWholeDaysMode: RenderWholeDaysMode;
}
export enum RenderWholeDaysMode {
    ShortDaysOnly = 0,
    Always = 1
}

interface ResourcePlanningSchedulerSettingsPlanningBoardColumnViewModel {
    Width: number;
    Title: string;
}
interface ResourcePlanningSchedulerSettingsPlanningBoardTimeHeaderViewModel {
    GroupBy: "Hour" | "Day" | "Week" | "Month" | "Year";
    Format: string;
}
interface AbsenceTimeAssignment {
    StartIst: string;
    EndeIst: string;
}

export interface ResourcePlanningSchedulerCapacitySettings {
    ColorAbsent: string;
    ColorAssignment: string;
    ColorExternal: string;
    ColorInternal: string;
    ColorOver: string;
    BusinessStartsTime: string;
    BusinessEndsTime: string;
    BusinessWorkHours: number;
    BusinessTimeExpandViewByXHours: number;
    ShowOverload: boolean;
    SlotPlanning_RestrictionMaingroup: boolean;
    SlotPlanning_RestrictionGroup: boolean;
    CapaItemOrder: Array<number>;
}

export interface DropDownFilterOptions {
    maingroups: DDFilterOpt,
    groups: DDFilterOpt,
    codes: DDFilterOpt
}

interface DDFilterOpt {
    template: string;
    url: string;
    dataSourceKey: string;
    dataSourceText: string;
    multiselect?: boolean;
}

export interface CopiedAssignmentInfo {
    projNr: string;
    pIndex: number;
    eventEntity: ResourcePlanningSchedulerEventViewModel;
}

export interface MovedAssignmentInfo {
    projNr: string;
    pIndex: number | null;
    start: string;
    end: string;
    resourceId: string;
    arbeitsbeginnist: string | null;
    arbeitsendeist: string | null;
    resourceName: string;
    utilization: number;
    epochStart: number;
    epochEnd: number;
    epochWorkStart: number;
    epochWorkEnd: number;
    continuationJourney: number;
    lockId: number;
    gruppenZaehler: number;
    projektZaehler: number;
    gruppierung: number;
    travelDataReset: boolean;
    otherAssignmentsChanged: boolean;
    recordRight: {
        CanRead: boolean;
        CanWrite: boolean;
    };
    AssignmentUtilizationInfo: AssignmentUtilizationInfo;
    IconInfo: {
        HexCode: string,
        Color: string
    }
    StatusMarkingCode?: string;
    StatusMarkingColor?: string;
    StatusSend?: number;
}


export interface OverlapPresenceTimeView {
    projNr: string;
    pindex: number | null;
    isGuid: string;
    bemerkung: string;
    startIst: string;
    endeIst: string;
    arbeitsbeginnIst: string;
    arbeitsendeIst: string;
    kennung: string;
    container: string;
    ressNr: string;
    grNr: number;
    fixiertStart: boolean;
    fixiertEnde: boolean;
}
export interface OverlapPresenceTimeLists {
    assignmetsToSplit: OverlapPresenceTimeView[];
    assignmentsWithFixStartOrEnd: OverlapPresenceTimeView[];
    showCountainerWarning: boolean;
}

export interface WorkingTimeFittedInfo {
    projNr: string;
    pIndex: number | null;
    arbeitszeit: number | null;
    endeIst: string;
    arbeitsendeist: string | null;
    SendState: number;
    StatusMarkingCode: string;
    StatusMarkingColor: string;
}

export interface AssignmentUtilizationInfo {
    offset: number;
    capacityDaysAll: number;
    workDaysAll: number;
    arrival: Array<number>;
    departure: Array<number>;
    pause: Array<number>;
    work: Array<number>;
    capacity: Array<number>;
}